{
  "Actions": {
    "actions": "Veiksmai",
    "back": "Atgal",
    "click here": "Spauskite čia",
    "collapse": "Suskleisti",
    "expand": "Išskleisti",
    "go to vehicle": "Eiti prie transporto"
  },
  "Alert": {
    "Account is already activated": "Paskyra jau aktyvuota.",
    "action failed": "Veiksmas nepavyko dėl klaidos",
    "add company card success": "Nauja įmonės kortelė sėkmingai pridėta.",
    "add driver success": "Vairuotojas sėkmingai pridėtas",
    "add integration success": "Integracija sėkmingai sukurta.",
    "add vehicle empty imei info": {
      "description": "Transportui nepriskirtas IMEI, todėl nebus galima atsisiųsti jos failų. Norėdami tai padaryti, įveskite galiojantį IMEI.",
      "title": "Transportas sėkmingai pridėtas, tačiau IMEI nepriskirtas."
    },
    "add vehicle success": "Transportas sėkmingai pridėtas",
    "An unhandled error occured while processing this request": "Apdorojant šią užklausą įvyko neapdorota klaida.",
    "Another driver is registered under this card number.": "Pagal šį kortelės numerį yra užregistruotas kitas vairuotojas.",
    "apply all driver schedules success": "Tvarkaraštis sėkmingai pridėtas visiems vairuotojams.",
    "apply all vehicle schedules success": "Tvarkaraštis sėkmingai pridėtas prie viso transporto.",
    "apply driver schedules success": "Tvarkaraštis sėkmingai pridėtas prie {{resourceCount}} vairuotojų.",
    "apply vehicle schedules success": "Tvarkaraštis sėkmingai pridėtas prie {{resourceCount}} transporto.",
    "cancel invitation success": "Kvietimas sėkmingai atšauktas.",
    "Card number must be 16 characters in length.": "Vairuotojo ID turi būti 16 simbolių ilgio.",
    "CCA file download success": "Company Card Authenticator buvo sėkmingai atsisiųstas.",
    "Comment must not be longer than 255 characters.": "Aprašymui leidžiamas simbolių skaičius – 255.",
    "Company card with such ID already exists.": "Įmonės kortelė su tokiu identifikatoriumi jau egzistuoja.",
    "Company card with such name already exists.": "Įmonės kortelė su tokiu pavadinimu jau egzistuoja.",
    "Company not found": "Įmonė nerasta.",
    "Company not found.": "Įmonė nerasta.",
    "Company with this LZ client code already exists.": "Įmonė su šiuo Teltonika kodu jau egzistuoja.",
    "create client company success": "Sėkmingai sukurta nauja klientų įmonė.",
    "create company success": "Įmonė sėkmingai įkurta.",
    "create schedule success": "Naujas tvarkaraštis sėkmingai sukurtas.",
    "credits overdraft activated": "Kredito limitas sėkmingai aktyvuotas",
    "credits overdraft deactivated": "Kredito limitas sėkmingai deaktyvuotas",
    "disable integration success": "Integracija sėkmingai išjungta.",
    "Driver duplication.": "Vairuotojų duplikavimas.",
    "Driver name contains invalid characters.": "Vairuotojo varde yra neleistini simboliai.",
    "Driver name must be 3-50 characters long.": "Vairuotojo vardas turi būti 3–50 simbolių ilgio.",
    "Driver with such card number already exists.": "Vairuotojo ID jau egzistuoja.",
    "Drivers schedules were not found": "Vairuotojų tvarkaraščių nerasta.",
    "edit company card success": "Įmonės kortelė sėkmingai redaguota.",
    "edit integration success": "Integracija sėkmingai atlikta.",
    "edit schedule success": "Tvarkaraštis sėkmingai redaguotas.",
    "edit user description": "Pakeitimai įsigalios, kai redagavęs naudotojas atsijungs.",
    "Email recipient was not found.": "El. pašto gavėjas nerastas.",
    "email transfer edit recipient success": "El. pašto gavėjo duomenys buvo sėkmingai pakeisti.",
    "email transfer new recipient success": "El. pašto gavėjas sėkmingai pridėtas.",
    "email transfer remove recipient success": "El. pašto gavėjas buvo sėkmingai pašalintas.",
    "enable integration success": "Integracija sėkmingai įjungta.",
    "error": {
      "import failed": "Nepavyko importuoti failo. Pašalinkite failą, įsitikinkite, kad duomenys atitinka reikalaujamą struktūrą, ir vėl įkelkite failą.",
      "import failed description": "Ištrinkite failą, įsitikinkite, kad duomenys atitinka reikalaujamą struktūrą, ir vėl įkelkite failą.",
      "import failed title": "Importavimas nepavyko. Duomenys neatitinka failo struktūros."
    },
    "general settings update success": "Nustatymai sėkmingai pakeisti.",
    "global schedule success": "Globalus tvarkaraštis sėkmingai sukurtas.",
    "Id must be of digits and letters only": "ID turi būti sudarytas tik iš skaitmenų ir raidžių",
    "Id must be of length 6 to 8": "ID ilgis turi būti nuo 6 iki 8 simbolių",
    "Imei must be 15 characters long.": "IMEI turi būti 15 simbolių ilgio.",
    "Imei must be numeric.": "IMEI laukelyje leidžiama įvesti tik skaitmenines reikšmes.",
    "integration editing cancelled": "Integracijos redagavimas atšauktas.",
    "Integration is disabled. Enable it first before retrying": "Integracija išjungta. Pirmiausia ją įjunkite, tada bandykite dar kartą.",
    "Invalid email address": "Neteisingas el. pašto adresas.",
    "Invalid format.": "Neteisingas failo formatas",
    "You cannot delete a company you are a member of.": "Šiuo metu pasirinktos įmonės ištrinti negalima. Prašome pasirinkti kitą įmonę ir pakartoti veiksmą.",
    "LZ client code not found.": "Teltonika kodas nerastas.",
    "move company success": "Įmonė „{{sourceCompany}}“ buvo sėkmingai perkelta į „{{targetCompany}}“.",
    "New name must be different from the current name.": "Naujas pavadinimas turi skirtis nuo dabartinio pavadinimo.",
    "news created": "Naujiena sėkmingai sukurta.",
    "news deleted": "Naujiena sėkmingai ištrinta.",
    "news edited": "Naujiena sėkmingai redaguota.",
    "news published": "Naujiena sėkmingai paskelbta.",
    "Number must be provided.": "Reikia nurodyti numerį.",
    "Number must not be longer than 30 characters.": "Valstybinio numerio ilgis negali viršyti 30 simbolių.",
    "One or more selected companies have child companies and cannot be deleted.": "Viena ar kelios pasirinktos įmonės turi dukterines įmones ir negali būti ištrintos.",
    "One or more validation errors occured while parsing csv file. Please use template file for reference.": "Analizuojant CSV failą įvyko viena ar daugiau patvirtinimo klaidų. Prašome naudoti šabloną kaip pavyzdį.",
    "One or more validation errors occured.": "Įvyko viena ar daugiau patvirtinimo klaidų.",
    "quick schedule created": {
      "description": {
        "drivers": "Duomenų atsisiuntimas bus pradėtas, kai tik bus nustatytas vairuotojo ryšys su TachoSync.",
        "vehicles": "Duomenų atsisiuntimas bus pradėtas, kai tik bus nustatytas transporto ryšys su TachoSync."
      },
      "title": "Greitasis tvarkaraštis sėkmingai sukurtas.",
      "title multiple drivers": "Sėkmingai sukurtas greitasis tvarkaraštis {{driverNum}} vairuotojams.",
      "title multiple vehicles": "Sėkmingai sukurtas greitasis tvarkaraštis {{vehicleNum}} transporto priemonėms.",
      "title single driver": "Greitasis tvarkaraštis sėkmingai sukurtas."
    },
    "Quick schedule for vehicle is already created.": "Greitasis transporto tvarkaraštis jau sudarytas.",
    "Quick schedule is already assigned to the driver.": "Vairuotojui jau priskirtas greitasis tvarkaraštis.",
    "remove company card success": "Įmonės kortelė sėkmingai pašalinta.",
    "resend invitation success": "Kvietimas buvo sėkmingai išsiųstas pakartotinai.",
    "retry integration success": "Integracija „{{integrationName}}“ sėkmingai užbaigta.",
    "retry interrupted integration success": "Integracija „{{integrationName}}“ pakartos sinchronizavimą praleistų failų. Prašome grįžti vėliau ir patikrinti būseną.",
    "session expired": "Jūsų sesija baigėsi. Prašome prisijungti dar kartą.",
    "successfully activate vehicle multiple": "{{resourceString}} transporto priemonės sėkmingai aktyvuotos.",
    "successfully activate vehicle single": "Transporto priemonė sėkmingai aktyvuota.",
    "successfully assigned schedules": {
      "multiple": "Tvarkaraščiai sėkmingai priskirti.",
      "single": "Tvarkaraštis sėkmingai priskirtas."
    },
    "successfully deactivate vehicle multiple": "{{resourceString}} transporto priemonės sėkmingai deaktyvuotos.",
    "successfully deactivate vehicle single": "Transporto priemonė sėkmingai deaktyvuota.",
    "successfully deleted": "{{resourceString}} sėkmingai ištrintas.",
    "successfully edited": "{{resourceString}} sėkmingai redaguota.",
    "successfully exported": "$t(General##{{tableName}}) sėkmingai eksportuota.",
    "successfully imported": "{{resourceString}} sėkmingai importuota.",
    "successfully move vehicles multiple": "{{resourceString}} buvo sėkmingai perkelti į {{companyString}}.",
    "successfully move vehicles single": "{{resourceString}} buvo sėkmingai perkeltas į {{companyString}}.",
    "successfully remove driver schedules multiple": "Tvarkaraščiai sėkmingai pašalinti iš {{resourceString}} vairuotojų.",
    "successfully remove driver schedules single": "Tvarkaraščiai sėkmingai pašalinti iš {{resourceString}} vairuotojo.",
    "successfully remove vehicle schedules multiple": "Tvarkaraščiai sėkmingai pašalinti iš {{resourceString}} transporto priemonių.",
    "successfully remove vehicle schedules single": "Tvarkaraščiai sėkmingai pašalinti iš {{resourceString}} transporto priemonės.",
    "successfully removed": "{{resourceString}} sėkmingai pašalintas.",
    "The company with such name already exists.": "Įmonė su tokiu pavadinimu jau egzistuoja.",
    "User is already invited.": "Naudotojas jau pakviestas.",
    "User is not invited": "Naudotojas nėra pakviestas.",
    "Vehicle duplication.": "Transporto priemonės dubliavimas.",
    "Vehicle number contains invalid characters.": "Valstybinis numeris turi neteisingų simbolių.",
    "Vehicle schedule was not found": "Transporto priemonės tvarkaraštis nerastas.",
    "Vehicle successfully activated": "Transporto priemonė sėkmingai aktyvuota.",
    "Vehicle with such IMEI already exists.": "Transporto priemonė su šiuo IMEI jau egzistuoja",
    "Vehicle with such Imei number already exists.": "IMEI jau egzistuoja.",
    "Vehicle with such number (VRN) already exists.": "Transporto priemonė su šiuo valstybiniu numeriu jau egzistuoja",
    "Vehicles schedules were not found": "Transporto priemonių tvarkaraščių nerasta."
  },
  "Auth": {
    "account verification description": "Reikalingas patvirtinimo kodas. Patikrinkite savo autentifikavimo programėlę ir įveskite žemiau pateiktą kodą, kad prisijungtumėte.",
    "account verification": {
      "check autheticator": "Patikrinkite savo autentifikavimo patvirtinimo programėlę",
      "check email": "Patikrinkite savo el. paštą",
      "code required": "Reikalingas patvirtinimo kodas.",
      "code sent to email": "Kodas išsiųstas į jūsų el. paštą",
      "code valid": "Kodas galioja keletą minučių.",
      "enter code below": "ir įveskite žemiau nurodytą kodą, kad prisijungtumėte."
    },
    "authenticator": "Autentifikavimo programa",
    "authenticator verification description": "Reikalingas patvirtinimo kodas. Patikrinkite savo autentifikavimo patvirtinimo programėlę ir įveskite žemiau nurodytą kodą, kad prisijungtumėte.",
    "back to sign in screen": "Grįžti į prisijungimo ekraną",
    "check email": "Patikrinkite savo pašto dėžutę ir spustelėkite gautą nuorodą, kad atstatytumėte slaptažodį.",
    "community forum": "Naudotojų palaikymo forumas",
    "contact us": "Susisiekite su mumis",
    "create password": "Sukurti slaptažodį",
    "did not receive": "Negavote nuorodos?",
    "do not have account": "Dar neturite paskyros?",
    "email": "El. paštas",
    "enter current password": "Įveskite dabartinį slaptažodį",
    "enter email": "Įveskite žemiau savo registruotą el. pašto adresą, kad gautumėte slaptažodžio atkūrimo instrukcijas.",
    "enter here": "Įveskite čia",
    "enter new password": "Įveskite naują slaptažodį",
    "enter numbers only": "Įveskite tik skaičius (0–9)",
    "example": "Pvz.:",
    "failed to login": "Įvestas el. pašto adresas arba slaptažodis yra neteisingas.",
    "forgot your password": "Pamiršote slaptažodį?",
    "forgot password": "Pamiršote slaptažodį?",
    "go to login": "Eiti į prisijungimo puslapį",
    "google authenticator": "Google Authenticator",
    "hide password": "Paslėpti slaptažodį",
    "invalid email format": "Neteisingas el. pašto formatas",
    "invalid password format": "Neteisingas slaptažodžio formatas",
    "Invitation expired": "Kvietimo nuoroda nebegalioja arba buvo panaikinta.",
    "link sent": "Nuoroda išsiųsta!",
    "login title": "Prisijungti",
    "microsoft authenticator": "„Microsoft Authenticator“",
    "new password": "Naujas slaptažodis",
    "password": "Slaptažodis",
    "password changed": "Slaptažodis sėkmingai pakeistas.",
    "privacy policy": "Naudodami <1>TachoSync</1>, sutinkate su mūsų <3>Privatumo politika</3>.",
    "remember password": "Ar prisimenate savo slaptažodį?",
    "repeat new password": "Pakartokite naują slaptažodį",
    "repeat password": "Pakartokite slaptažodį",
    "required": "Reikalaujama",
    "resend": "Siųsti dar kartą",
    "reset password": "Atkurti slaptažodį",
    "send reset link": "Siųsti atkūrimo nuorodą",
    "show password": "Rodyti slaptažodį",
    "sign in": "Prisijungti",
    "sign in to tacho": "Prisijunkite prie savo TachoSync paskyros",
    "sign out": "Atsijungti",
    "sign up": "Registruotis",
    "teltonika telematics": "Teltonika Telematics",
    "terms and conditions": "Aš suprantu ir sutinku su Teltonika <1>Paslaugų teikimo sąlygomis</1> bei <2>Duomenų tvarkymo sutartimi</2>.",
    "wiki": "Telematics Wiki žinių bazė"
  },
  "Button": {
    "accept": "Sutinku",
    "accept all": "Priimti viską",
    "accept selected": "Patvirtinti pasirinkimą",
    "actions": "Veiksmai",
    "activate": "Aktyvuoti",
    "add": "Pridėti",
    "add driver": "Pridėti vairuotoją",
    "add integration": "Pridėti integraciją",
    "add to schedule": "Įtraukti į tvarkaraštį",
    "add vehicle": "Pridėti transportą",
    "all drivers": "Visi vairuotojai",
    "all vehicles": "Visas transportas",
    "apply": "Taikyti",
    "assign": "Priskirti",
    "back": "Atgal",
    "back to sign in": "Grįžti į prisijungimą",
    "cancel": "Atšaukti",
    "change": "Pakeisti",
    "child company": "Dukterinė įmonė",
    "clear": "Išvalyti",
    "clear all": "Išvalyti viską",
    "close": "Uždaryti",
    "confirm": "Patvirtinti",
    "continue": "Tęsti",
    "continue to TachoSync": "Toliau į TachoSync",
    "copy to clipboard": "Kopijuoti į iškarpinę",
    "copied": "Kopijuota",
    "create": "Sukurti",
    "create schedule": "Sukurti tvarkaraštį",
    "deactivate": "Deaktyvuoti",
    "default view": "Numatytasis vaizdas",
    "delete": "Ištrinti",
    "deselect all": "Atžymėti viską",
    "disable": "Išjungti",
    "don't apply": "Netaikyti",
    "download": "Atsisiųsti",
    "edit": "Redaguoti",
    "edit driver": "Redaguoti vairuotoją",
    "edit integration": "Redaguoti integraciją",
    "edit vehicle": "Redaguoti transportą",
    "enable": "Įjungti",
    "export": "Eksportuoti",
    "export drivers": "Eksportuoti vairuotojus",
    "export vehicles": "Eksportuoti transportą",
    "file settings": "Failų nustatymai",
    "filtered": "Filtruota",
    "filters": "Filtrai",
    "find device": "Rasti įrenginį",
    "finish": "Baigti",
    "first page": "Pirmasis puslapis",
    "generate": "Generuoti",
    "generate report": "Generuoti ataskaitą",
    "get started": "Pradėti",
    "go back": "Grįžti atgal",
    "yes": "Taip",
    "import": "Importuoti",
    "import drivers": "Importuoti vairuotojus",
    "import vehicles": "Importuoti transportą",
    "inline actions": {
      "cancel invitation": "Atšaukti kvietimą",
      "download file driver": "Atsisiųsti",
      "download file vehicle": "Atsisiųsti",
      "download monitoring": "Atsisiuntimo stebėjimas",
      "download status": "Atsisiuntimo būsena",
      "edit analysis provider": "Redaguoti",
      "edit company": "Redaguoti įmonę",
      "edit driver": "Redaguoti vairuotoją",
      "edit integration": "Redaguoti integraciją",
      "edit user": "Redaguoti naudotoją",
      "edit vehicle": "Redaguoti transportą",
      "resend invitation": "Pakartotinai išsiųsti kvietimą",
      "retry analysis provider": "Bandyti dar kartą",
      "retry integration": "Bandyti dar kartą"
    },
    "invite": "Kviesti",
    "invite user": "Kviesti naudotoją",
    "history": "Istorija",
    "last page": "Paskutinis puslapis",
    "max download files": "Vienu metu galite atsisiųsti tik {{maxNumber}} failus.",
    "more actions": "Daugiau veiksmų",
    "more filters": "Daugiau filtrų",
    "more options": "Daugiau parinkčių",
    "move": "Perkelti",
    "new client": "Naujas klientas",
    "next": "Toliau",
    "next month": "Kitas mėnuo",
    "next page": "Kitas puslapis",
    "only essential": "Tik būtiniausi",
    "open TachoSync": "Atidaryti TachoSync",
    "pages of": "iš {{total}}",
    "pause": "Sustabdyti",
    "previous": "Ankstesnis",
    "previous month": "Ankstesnis mėnuo",
    "previous page": "Ankstesnis puslapis",
    "quick schedule": "Greitas tvarkaraštis",
    "refresh page": "Atnaujinti puslapį",
    "reject all": "Atmesti viską",
    "remove": "Pašalinti",
    "remove schedules": "Pašalinti tvarkaraščius",
    "reset": "Atstatyti",
    "reset to default": "Atkurti numatytuosius nustatymus",
    "resume": "Tęsti",
    "return home": "Eiti į pradžią",
    "rows selected": "{{count}} Pasirinkta",
    "save": "Išsaugoti",
    "schedules": "Tvarkaraščiai",
    "select image": "Pasirinkti paveikslėlį",
    "select rows": "Pasirinkti eilutes",
    "selected": "Pasirinkta",
    "send code": "Siųsti kodą",
    "settings": "Nustatymai",
    "table view": "Lentelės peržiūra",
    "testing connection": "Tikrinamas ryšys...",
    "verify": "Patikrinti"
  },
  "Company cards": {
    "add new": "Pridėti naują",
    "badge tooltip": {
      "Disconnected": "Prarastas ryšys su TachoSync. Paskutinis prisijungimas {{connectionDate}}.",
      "Expired": "Kortelė deaktyvuota, nes pasibaigė jos galiojimo laikas.",
      "Inactive": "Niekada nepavyko užmegzti ryšio su TachoSync.",
      "Online": "Sėkmingai prisijungta prie TachoSync ir vyksta aktyvus ryšys."
    },
    "card expired": "Kortelės galiojimo laikas pasibaigęs: {{date}}",
    "card id": "Kortelės ID",
    "card number": "Kortelės numeris",
    "card number tooltip": "Kortelės numeris bus rodomas po pirmojo sėkmingo autorizavimo.",
    "cca version": "CCA versija",
    "company card id": "Įmonės kortelės ID",
    "edit card": "Redaguoti kortelę",
    "edit company card": "Redaguoti įmonės kortelę",
    "expiry": "Galiojimo pabaiga",
    "expiry date": "Galiojimo pabaigos data: {{date}}",
    "expiry tooltip": "Kortelės galiojimo pabaigos data bus rodoma po pirmojo sėkmingo autorizavimo.",
    "latest version": "Naujausia",
    "remove card": "Išimti kortelę",
    "remove company card": "Pašalinti įmonės kortelę?",
    "remove company card description": "Ar tikrai norite pašalinti įmonės kortelę „{{cardName}}“? Šio veiksmo negalima atšaukti.",
    "status": "Būklė",
    "update version warning": "Yra naujesnė versija.  Rekomenduojame ją atnaujinti, kad programa veiktų sklandžiau.",
    "valid until": "Galioja iki",
    "version details after connection is established": "Versijos informacija bus rodoma čia po pirmojo prisijungimo naudojant įmonės kortelę."
  },
  "Cookies": {
    "accept": "Sutinku",
    "always active": "Visada aktyvus",
    "analytics cookies": "Analitikos slapukai",
    "analytics cookies description": "Šie sekimo įrankiai naudojami analizei – jie padeda rinkti duomenis, leidžiančius mums suprasti, kaip naudotojai sąveikauja su mūsų svetainėmis. Ši informacija leidžia mums tobulinti turinį ir kurti geresnes funkcijas, kurios pagerina naudotojo patirtį. Šios kategorijos slapukus galima išjungti.",
    "cookie banner message": "Mes ir atrinkti tretieji asmenys naudojame slapukus ar panašias technologijas techniniais tikslais, o gavę jūsų sutikimą – ir kitais tikslais, nurodytais <1>slapukų politikoje</1>.",
    "cookie modal title": "Mes naudojame slapukus",
    "cookie policy": "slapukų politika",
    "essential cookies": "Būtini slapukai",
    "essential cookies description": "Šie sekimo įrenginiai naudojami veiklai, kuri yra būtina jūsų užsakytai paslaugai teikti, ir šie slapukai nerenka apie jus informacijos, kuri galėtų būti naudojama rinkodaros tikslais, taip pat neįsimena, kokias interneto svetaines lankėte. Šios kategorijos slapukų negalima išjungti.",
    "text": "Šioje svetainėje saugomi duomenys, pvz., slapukai, siekiant užtikrinti būtiną svetainės funkcionalumą, įskaitant analizę."
  },
  "Dashboard": {
    "added": "Pridėta",
    "Available": "Prieinama",
    "cards": "Kortelės",
    "card tooltips": {
      "connectivity": "<strong>Prisijungęs:</strong>\nĮrenginys prisijungė per pastarąsias 24 valandas\n\n<strong>Neprisijungęs:</strong>\nĮrenginys neprisijungė per pastarąsias 24 valandas\n\n<strong>Neaktyvus:</strong>\nĮrenginys niekada neužmezgė sėkmingo ryšio su „TachoSync“",
      "driver downloads": "<strong>Laiku:</strong>\n0–14 dienų nuo paskutinio atsisiuntimo\n\n<strong>Netrukus:</strong>\n15–28 dienų nuo paskutinio atsisiuntimo\n\n<strong>Vėluojama:</strong>\n29 ir daugiau dienų nuo paskutinio atsisiuntimo\n\n<strong>Nėra atsisiuntimų:</strong>\nDar nebuvo atsisiųsta",
      "vehicle downloads": "<strong>Laiku:</strong>\n0–60 dienų nuo paskutinio atsisiuntimo\n\n<strong>Netrukus:</strong>\n61–90 dienų nuo paskutinio atsisiuntimo\n\n<strong>Vėluojama:</strong>\n91 ir daugiau dienų nuo paskutinio atsisiuntimo\n\n<strong>Nėra atsisiuntimų:</strong>\nDar nebuvo atsisiųsta"
    },
    "cc expiry": {
      "expired": "Pasibaigęs galiojimo laikas",
      "near expiry": "Artėja galiojimo pabaiga",
      "near expiry tooltip": "Galioja dar 3 mėnesius",
      "upcoming expiry": "Artėjantis galiojimo pabaigos terminas",
      "upcoming expiry tooltip": "Galioja dar 3–6 mėnesius"
    },
    "company cards": "Įmonės kortelės",
    "company cards expiration": "Įmonės kortelių galiojimo pabaiga",
    "connectivity": "Ryšys",
    "connectivity tabs": {
      "company cards": "Įmonės kortelės",
      "devices": "Įrenginiai"
    },
    "credit overdraft activated": "Naudodamiesi kredito limitu, galite išleisti iki {{overDraftAmount}} kreditų daugiau nei turite sąskaitoje.",
    "credits": "Kreditai",
    "credits health": {
      "Healthy": "Gera būklė",
      "InOverdraft": "Naudojamas kredito limitas",
      "LimitReached": "Pasiektas limitas",
      "LowCredits": "Mažai kreditų",
      "OverdraftLimitReached": "Pasiektas limitas"
    },
    "credits history": "Kredito istorija",
    "credits history actions": {
      "BonusCredits": "Bonus kreditai",
      "CreditsExpiration": "Kreditų galiojimo pabaiga",
      "Deduction": "Mėnesinis atskaitymas",
      "FreeTrial": "Pridėti Demo kreditai",
      "MonthlyDeduction": "Mėnesinis atskaitymas",
      "Purchase": "Pridėti kreditai",
      "WebTachoLicenseConversion": "Migracija"
    },
    "credits statuses": {
      "available": "Prieinama",
      "balance": "Balansas",
      "overdraft": "Kredito limitas",
      "remaining overdraft": "Kredito limito viršijimo likutis",
      "reserved": "Rezervuota"
    },
    "Deactivated": "Deaktyvuota",
    "deducted": "Išskaičiuota",
    "demo credits": {
      "demo": "Demo",
      "demo credits expired tooltip": "Demo kreditai pasibaigė. Norėdami toliau naudotis TachoSync, įsigykite kreditų.",
      "demo credits used up tooltip": "Visi Demo kreditai išnaudoti. Norėdami toliau naudotis TachoSync, įsigykite kreditų.",
      "demo info tooltip": "Demo kreditai aktyvuojami po pirmojo IMEI prisijungimo ir galioja 90 dienų."
    },
    "device status": "Įrenginio būsena",
    "devices": "Įrenginiai",
    "driver data": "Vairuotojų duomenys",
    "driver downloads": "Vairuotojų atsisiuntimai",
    "DueSoon": "Netrukus",
    "estimated": "Numatoma",
    "expires": "Galioja iki",
    "how credits work": {
      "bottom content": {
        "header": "Kada rezervuojamas kreditas?",
        "table": {
          "body": {
            "any": "Bet kuris",
            "any behaviour": "Naujas kreditas nerezervuojamas - esama rezervacija galioja iki mėnesio pabaigos.",
            "newly assigned": "Naujai priskirti",
            "newly assigned behaviour": "Rezervuota prisijungus. Po pirmojo atsisiuntimo perkelta į VIN.",
            "none": "Nėra",
            "none behaviour": "Kreditas nerezervuotas. Atsisiuntimas prasidės tik tada, kai bus priskirtas įrenginys.",
            "replaced vin known": "Pakeistas (žinomas VIN)",
            "replaced vin known behaviour": "Naujo kredito nesuteikiama. Galioja esama rezervacija."
          },
          "head": {
            "credit behaviour": "Kreditų elgsena",
            "device": "Įrenginys",
            "vehicle status": "Transporto būsena"
          }
        }
      },
      "button tooltip": "Sužinokite, kaip veikia kreditai",
      "main description": "TachoSync kreditai galioja 12 mėnesių. Kiekvienas naujas pirkimas pratęsia galiojimo terminą dar 12 mėnesių, užtikrinant, kad jūsų kreditai bus prieinami tol, kol jūs aktyviai naudojatės paslauga.",
      "main title": "Kaip veikia kreditai",
      "middle content": {
        "description": "Jūsų transporto parko kreditų naudojimas tiksliai atspindi, kiek transporto priemonių yra aktyvių, remiantis unikaliu VIN kodu. Įrenginiai gali būti keičiami, perkeliami iš vienos transporto priemonės į kitą arba perrašomi kitoms dukterinėms įmonėms nenaudojant papildomų kreditų, jei transporto priemonė buvo identifikuota.",
        "header": "Kreditas skiriamas pagal aktyvią transporto priemonę, o ne pagal įrenginį.",
        "read more on wiki": "Daugiau informacijos rasite Wiki"
      },
      "top content": {
        "active vehicle": "Aktyvus transportas",
        "device can change freely": "Įrenginį galima laisvai keisti",
        "equals one credit": "= 1 kreditas",
        "identified by IMEI": "Atpažįstamas pagal IMEI",
        "identified by VIN": "Atpažįstamas pagal VIN",
        "tracking device": "Sekimo įrenginys"
      }
    },
    "Inactive": "Neaktyvus",
    "last 12 months": "Paskutiniai 12 mėnesių",
    "news": "Naujienos",
    "no history to show": "Nėra istorijos, kurią būtų galima parodyti",
    "no news": "Nėra naujienų",
    "no results": "Nerasta rezultatų",
    "NoDownloads": "Nėra atsisiuntimų",
    "Offline": "Neprisijungęs",
    "Online": "Prisijungęs",
    "OnTime": "Laiku",
    "Overdue": "Vėluojama",
    "Remaining": "Likusi dalis",
    "Reserved": "Rezervuota",
    "response error": "Įvyko klaida. Pabandykite atnaujinti puslapį",
    "timeline": "Laiko juosta",
    "tooltip": {
      "click to expand": "Spustelėkite, kad išplėstumėte",
      "connected card expire soon": "Kortelės galiojimas netrukus baigsis: {{expirationDate}}",
      "disconnected card": "Įmonės kortelė atjungta. Paskutinis matymo laikas: {{lastSeen}}.",
      "disconnected card expire soon": "Įmonės kortelė atjungta. Paskutinis prisijungimas: {{lastSeen}}.  Kortelės galiojimas baigsis netrukus: {{expirationDate}}.",
      "expired card": "Kortelės galiojimo laikas baigėsi {{expirationDate}}. Pakeiskite įmonės kortelę galiojančia.",
      "offline card": "Įmonės kortelė neveikia. Paskutinis prisijungimas: {{lastSeen}}.",
      "take me there": "Nukreipti mane ten"
    },
    "Upcoming charge": "Būsimas mokestis",
    "vehicle data": "Transporto duomenys",
    "vehicle downloads": "Transporto atsisiuntimai",
    "view history": "Peržiūrėti istoriją"
  },
  "Date picker": {
    "disableFuture": "Išjungimo data",
    "disablePast": "Išjungimo data",
    "invalid date format": "Neteisingas datos formatas",
    "invalidDate": "Neteisinga data",
    "maxDate": "Neteisinga data",
    "minDate": "Neteisinga data",
    "shouldDisableDate": "Išjungimo data"
  },
  "Details": {
    "activities": "Veikla",
    "add new email recipient": {
      "choose a file format": "Pasirinkite failo formatą",
      "enter email": "Įveskite el. pašto adresą",
      "title": "Pridėti naują gavėją"
    },
    "api company id": "API įmonės ID",
    "autoAssignGlobalScheduleToDriver": "Paskirti bendrą tvarkaraštį naujiems vairuotojams",
    "autoAssignGlobalScheduleToVehicle": "Paskirti bendrą tvarkaraštį naujoms transporto priemonėms",
    "automaticDriverRegistrationEnabled": "Automatinis naujų vairuotojų registravimas",
    "card holder": "Kortelės savininko vardas ir pavardė",
    "client code": "Kliento kodas",
    "close details": "Uždaryti išsamią informaciją",
    "company": "Įmonė",
    "company cards": "Įmonės kortelės",
    "company cards limit reached": "Pasiekėte maksimalų įmonės kortelių skaičių šiai įmonei, {{currCount}}/{{maxCount}}.",
    "company settings": "Įmonės nustatymai",
    "Completed": "Užbaigta",
    "connection settings": "Ryšio nustatymai",
    "creator": "Kūrėjas",
    "credits": "Kreditai",
    "credits overdraft tooltip": "Atnaujinta mėnesinio kredito rezervavimo logika, leidžianti sąskaitoje turėti neigiamą likutį. Tai padės užtikrinti sklandesnį perėjimą iš Web Tacho be spaudimo nedelsiant įsigyti kreditą.",
    "current status": "Dabartinė būklė",
    "Daily": "Kasdien",
    "data types": "Duomenų tipai",
    "deactivated": "Deaktyvuota",
    "deactivated vehicle banner": {
      "description": "Kol transporto priemonė nebus aktyvuota, nauji kreditai nebus rezervuojami, o transporto failų atsisiųsti negalima.",
      "link": "Aktyvuoti transportą",
      "title": "Transportas deaktyvuotas"
    },
    "detailed speed": "Išsamūs greičio duomenys",
    "details": "Išsami informacija",
    "device imei": "Įrenginio IMEI",
    "device status": "Įrenginio būsena",
    "download status": "Atsisiuntimo būsena",
    "download time": "Atsisiuntimo trukmė",
    "DownloadPending": "Atsisiuntimas laukia",
    "driver": "Vairuotojas",
    "driver id": "Vairuotojo ID",
    "driver status": "Vairuotojo būsena",
    "drivers": "Vairuotojai",
    "edit": "Redaguoti",
    "edit user": "Redaguoti {{userEmail}}",
    "email limit reached": "Jūs pasiekėte maksimalų leidžiamą el. laiškų skaičių šiai įmonei.",
    "email transfer": "Siuntimas el. paštu",
    "email transfer info tooltip": "Naudodamiesi el. pašto perdavimo funkcija, galite gauti atsisiųstus tachografo duomenis el. paštu. Kai tvarkaraštis bus įvykdytas, sistema automatiškai persiųs el. laišką nustatytiems gavėjams. Kiekviena įmonė gali pridėti iki {{maxCount}} el. pašto gavėjų.",
    "endpointUrl": "Galutinio taško URL",
    "events and faults": "Įvykiai ir klaidos",
    "Every  days": "Kas {{count}} dienų",
    "Every month": "Kiekvieną mėnesį",
    "EveryDays": "Kas {{count}} dienų",
    "Feature not available in BETA version": "Ši funkcija nėra prieinama BETA versijoje",
    "file format": "Failo formatas",
    "file sync": "Failų sinchronizavimas",
    "general": "Bendra informacija",
    "host": "Pagrindinis serveris",
    "imei": "IMEI",
    "included": "Įtraukta",
    "integration method": {
      "Ftps": "FTPS",
      "Sftp": "SFTP",
      "Webhook": "Webhook"
    },
    "last activity": "Paskutinė veikla",
    "last download attempt": "Paskutinis atsisiuntimo bandymas",
    "last successful download": "Paskutinis sėkmingas atsisiuntimas",
    "Never": "Niekada",
    "next download": "Kitas atsisiuntimas",
    "next download attempt": "Kitas atsisiuntimo bandymas",
    "Next download attempt in  day": "Kitas atsisiuntimo bandymas po {{count}} dienos",
    "Next download attempt in  days": "Kitas atsisiuntimo bandymas po {{count}} dienų",
    "no company cards": "Įmonės kortelės nepridėtos.",
    "no driver schedule": "Vairuotojui nepriskirti jokie tvarkaraščiai.",
    "no recipients added": "Nepridėti gavėjai",
    "no vehicle schedule": "Transportui nepriskirti jokie tvarkaraščiai.",
    "not included": "Neįtraukta",
    "on next connection": "Kito prisijungimo metu",
    "open files": "Atidaryti failus",
    "open files disabled tooltip": "Šiam objektui nėra prieinamų failų.",
    "other": "Kita",
    "overview": "Apžvalga",
    "parent company": "Motininė įmonė",
    "password": "Slaptažodis",
    "port": "Port",
    "Quick schedule was completed": "Greitasis tvarkaraštis buvo užbaigtas",
    "remotePath": "Remote directory path",
    "remove": "Pašalinti",
    "remove email recipient": {
      "description": "Ar tikrai norite pašalinti šį el. pašto gavėją? Šio veiksmo negalima atšaukti.",
      "title": "Pašalinti {{userEmail}}?"
    },
    "remove schedule": "Pašalinti tvarkaraštį",
    "reserved": "Rezervuota",
    "schedule details": "Tvarkaraščio detalės",
    "schedule history": "Tvarkaraščių istorija",
    "schedule start time": "Pradžios laiko nustatymas",
    "schedules": "Tvarkaraščiai",
    "show less": "Rodyti mažiau",
    "show more": "Rodyti daugiau",
    "show older": "Rodyti senesnius",
    "status": "Būklė",
    "sub companies": "Dukterinės įmonės",
    "technical data": "Techniniai duomenys",
    "Upon device connection": "Prijungimas prie įrenginio",
    "username": "Naudotojo vardas",
    "users": "Naudotojai",
    "vehicles": "Transportas",
    "vrn": "VRN",
    "WaitingForDeviceConnection": "Laukiama įrenginio prisijungimo",
    "WaitingForScheduleStartTime": "Laukiama tvarkaraščio pradžios laiko"
  },
  "Dialog": {
    "account id": "Paskyros ID",
    "account id cannot contain more than": "Paskyros ID negali būti ilgesnis nei {{maxNumber}} simbolių",
    "activate vehicles": {
      "description": "Aktyvavus, transportas galės rezervuoti kreditus pagal unikalų mėnesinį ryšį. Ar tikrai norite aktyvuoti šį transportų skaičių?",
      "title": "Aktyvuoti transportą?"
    },
    "add": "Pridėti",
    "add company card": "Pridėti naują įmonės kortelę",
    "add driver": "Pridėti vairuotoją",
    "add integration": "Pridėti integraciją",
    "add new integration": {
      "description": "Pasirinkite integracijos tipą, kurį norite pridėti, ir kitame žingsnyje sukonfigūruokite detales.",
      "title": "Pridėti naują integraciją"
    },
    "add vehicle": "Pridėti transportą",
    "add vehicle description": "Pridėkite transportą rankiniu būdu įvedant visus registracijos duomenis.",
    "add vehicle imei in use accessible": {
      "description": "Šis IMEI jau susietas su kitu transportu. Perkelus jį, ta transportas bus atjungta nuo failų atsisiuntimo. Ar tikrai norite tęsti?",
      "title": "IMEI jau naudojamas",
      "vehicle imei": "Transportas, kurios IMEI kodas yra „{{imeiValue}}“:"
    },
    "all resource": "Visi {{resource}}",
    "api key": "API raktas",
    "api key placeholder": "Įveskite API raktą",
    "api key cannot contain more than": "API raktas negali būti ilgesnis nei {{maxNumber}} simbolių",
    "api key edit": {
      "dialog title": "Redaguoti API raktą „{{keyName}}“",
      "success banner": "API raktas sėkmingai redaguotas."
    },
    "api key name": "Raktinis pavadinimas",
    "api key name required": "Raktinis pavadinimas negali būti tuščias",
    "api key name too long": "Raktinio žodžio ilgis negali viršyti {{maxNumber}} simbolių",
    "api management": {
      "description": "Sukurkite savo API raktą, kad galėtumėte saugiai valdyti API prieigą prie mūsų sistemos ir užtikrinti sklandų integravimą su savo programine įranga bei darbo srautais. TachoSync API dokumentaciją rasite ",
      "generated api key": "Sukurtas API raktas",
      "success banner": "API raktas buvo sėkmingai sukurtas. Būtinai išsaugokite žemiau pateiktą informaciją, nes jos vėliau nebegalėsite peržiūrėti."
    },
    "cancel invitation": "Atšaukti kvietimą",
    "cancel invitation description": "Ar tikrai norite atšaukti kvietimą, skirtą {{userEmail}}?",
    "card holder name": "Kortelės savininko vardas ir pavardė",
    "card holder name not valid": "Kortelės savininko vardas ir pavardė negali būti ilgesni nei {{maxNumber}} simbolių",
    "card holder name should not be empty": "Kortelės savininko vardas ir pavardė neturi būti tušti",
    "card holder name too short": "Kortelės savininko vardas ir pavardė turi būti ne trumpesni nei {{minNumber}} simbolių",
    "card id not valid": "Kortelės identifikatorius negali būti ilgesnis nei {{maxNumber}} simbolių",
    "card id should contain only digits, letters and hyphens": "Kortelės identifikatorius turi būti sudarytas tik iš skaitmenų (0–9), raidžių A–F ir brūkšnelių (-).",
    "card id should contain only numbers": "Kortelės identifikatorius turi būti sudarytas tik iš skaičių",
    "card id should not be empty": "Kortelės ID laukelis neturi būti tuščias",
    "card id too short": "Kortelės ID turi būti sudarytas iš ne mažiau kaip {{minNumber}} simbolių",
    "card name": "Kortelės pavadinimas",
    "card name not valid": "Kortelės pavadinime negali būti daugiau nei {{maxNumber}} simbolių",
    "card name should not be empty": "Kortelės pavadinimas neturi būti tuščias",
    "card name too short": "Kortelės pavadinime turi būti ne mažiau kaip {{minNumber}} simbolių",
    "choose period": "Pasirinkite laikotarpį",
    "client company": "Kliento įmonė",
    "company": "Įmonė",
    "company card id": "Įmonės kortelės ID",
    "company name": "Įmonės pavadinimas",
    "company name in tachoSync": "Įmonės pavadinimas TachoSync",
    "company name placeholder": "Pvz.: Teltonika Telematics",
    "company settings": {
      "allow credits overdraft": "Leisti kredito limito viršijimą",
      "auto add new drivers": "Automatinis naujų vairuotojų registravimas",
      "auto add new drivers tooltip": "Kai tik atpažįstamas naujas vairuotojo ID, TachoSync automatiškai įtraukia jį į vairuotojų lentelę.",
      "auto assign global schedule to drivers": "Automatinis bendro tvarkaraščio priskyrimas naujiems vairuotojams",
      "auto assign global schedule to drivers tooltip": "Naujai užregistruotiems vairuotojams automatiškai taikomas bendrasis atsisiuntimo tvarkaraštis, užtikrinantis duomenų atsisiuntimą be rankinio įsikišimo.",
      "auto assign global schedule to vehicles": "Automatinis bendro tvarkaraščio priskyrimas naujoms transporto priemonėms",
      "auto assign global schedule to vehicles tooltip": "Naujai registruotoms transporto priemonėms automatiškai taikomas bendrasis atsisiuntimo tvarkaraštis, užtikrinantis duomenų atsisiuntimą be rankinio įsikišimo.",
      "auto download driver data": "Vairuotojo duomenų automatinis atsisiuntimas pirmą kartą prisijungus",
      "auto download driver data tooltip": "Automatiškai atsisiunčia vairuotojo kortelės duomenis, kai vairuotojas prisijungia pirmą kartą. Tai užtikrina, kad prieš nustatant tvarkaraščius būtų užfiksuota visa naujų vairuotojų veiklos istorija.",
      "auto update vehicle registration number": "Automatinis transporto registracijos numerio (VRN) atnaujinimas",
      "auto update vehicle registration number tooltip": "Kai ši funkcija įjungta, transporto sukūrimo metu įvestas VRN numeris po pirmojo sėkmingo atsisiuntimo pakeičiamas verte, nuskaityta iš tachografo duomenų.",
      "automatic initial vehicle download": "Automatinis transporto duomenų atsisiuntimas pirmojo prisijungimo metu",
      "automatic initial vehicle download tooltip": "Pirmą kartą prijungus transportą, jos duomenys atsisiunčiami automatiškai. Tai užtikrina, kad prieš nustatant tvarkaraščius būtų užfiksuota visa naujų transportų istorija.",
      "title": "Įmonės nustatymai"
    },
    "confirm add schedule": "Pridėti tvarkaraštį?",
    "confirm deactivate api key": {
      "description": "Ar tikrai norite išjungti API raktą „{{apiKeyName}}“?",
      "title": "Deaktyvuoti API raktą?"
    },
    "confirm deactivate integration": {
      "description": "Ar tikrai norite išjungti integraciją „{{integrationName}}“?",
      "title": "Išjungti integraciją?"
    },
    "confirm delete analysis providers": "Ar tikrai norite ištrinti šį analizės teikėjų skaičių? Šio veiksmo atšaukti negalima.",
    "confirm delete api credentials": "Ar tikrai norite ištrinti pasirinktus API prisijungimo duomenis? Šio veiksmo negalima atšaukti, o bet koks API iškvietimas, atliktas naudojant šiuos prisijungimo duomenis, bus nedelsiant atmestas.",
    "confirm delete companies": "Ar tikrai norite ištrinti pasirinktą įmonę? Šio veiksmo negalima atšaukti.",
    "confirm delete drivers": "Tai ištrins visus vairuotojų duomenis, tačiau vairuotojų failai bus išsaugoti. Ar tikrai norite ištrinti šį vairuotojų skaičių?",
    "confirm delete integrations": "Ar tikrai norite ištrinti šį integracijų skaičių? Šio veiksmo negalima atšaukti.",
    "confirm delete users": "Ar tikrai norite ištrinti šį naudotojų skaičių? Šio veiksmo atšaukti negalima.",
    "confirm delete vehicles": "Tai ištrins visus transportų duomenis, tačiau transportų failai bus išsaugoti. Ar tikrai norite ištrinti nurodytą transportų skaičių?",
    "confirm empty imei": {
      "description": "Jūs neužpildėte laukelio „IMEI“. Transporto be IMEI negali prisijungti prie TachoSync ir negali atsisiųsti failų. Ar tikrai norite tęsti?",
      "title": "IMEI neįtrauktas"
    },
    "convey integration": {
      "add": {
        "description": "Nustatykite Convey ryšį",
        "title": "Pridėti Convey integraciją"
      },
      "edit": {
        "description": "Nustatykite savo Convey prisijungimą",
        "title": "Redaguoti Convey integraciją"
      },
      "provider settings description": "Būtinai naudokite Convey pateiktus prisijungimo duomenis.",
      "provider settings title": "Tiekėjo nustatymai"
    },
    "create": "Sukurti",
    "create company": "Sukurti įmonę",
    "create company main description": "Pasirinkite, ar norite sukurti naują dukterinę įmonę šioje hierarchijoje, ar sukurti naują klientą, naudodami kliento LZ kodą.",
    "create new hierarchy": "Sukurti naują hierarchiją",
    "create news": "Sukurti naujieną",
    "create news description": "Trumpai pristatykite modalio turinį.",
    "create quick schedule": "Sukurti greitą tvarkaraštį",
    "create schedule": "Sukurti tvarkaraštį",
    "create schedule description": "Nustatykite automatinį failų atsisiuntimą, pasirinkdami datą, laiką ir pasikartojimo dažnumą. Sistema pati pasirūpins atsisiuntimu, užtikrindama atitiktį reikalavimams ir duomenų tikslumą be jūsų rankinio įsikišimo. Pradžios laiko negalima nustatyti praeityje.",
    "credits history": {
      "description": "Stebėkite savo dabartinį kreditų likutį ir peržiūrėkite istorinius duomenis.",
      "description generate report": "Stebėkite savo dabartinį kreditų likutį, peržiūrėkite istorinius duomenis ir sukurkite „.csv“ ataskaitą apie visus per pastaruosius 12 mėnesių sunaudotus kreditus.",
      "generate report description": "Pasirinkite bet kurį laikotarpį per pastaruosius 12 mėnesių ir sukurkite ataskaitą apie sunaudotus kreditus.",
      "generate report title": "Sukurti ataskaitą",
      "title": "Kredito istorija"
    },
    "custom period": "Pasirinktas laikotarpis",
    "date display format": "Datos rodymo formatas",
    "date range": "Laikotarpis",
    "deactivate vehicle": "Deaktyvuoti šį transportą",
    "deactivate vehicle description": "Deaktyvuotos transporto priemonės negaus naujų kreditų ir negalės atsisiųsti duomenų",
    "deactivate vehicles": {
      "description": "Deaktyvuotos transporto priemonės negaus naujų kreditų, o duomenų atsisiuntimas joms bus užblokuotas.",
      "title": "Deaktyvuoti transportą?"
    },
    "delete": "Ištrinti",
    "delete analysis providers": "Ištrinti analizės paslaugų teikėjus?",
    "delete api credentials": "Ištrinti API prisijungimo duomenis?",
    "delete companies": "Ištrinti įmones?",
    "delete companies warning": "Atlikus įmonių ištrinimo veiksmą, bus ištrinti visi toms įmonėms priklausantys ištekliai.",
    "delete drivers": "Ištrinti vairuotojus?",
    "delete integrations": "Ištrinti integracijas?",
    "delete news": "Ištrinti naujieną?",
    "delete news description": "Ar tikrai norite ištrinti pasirinktas naujienas?",
    "delete unpublished release notes": "Ištrinti nepaskelbtas versijos pastabas?",
    "delete unpublished release notes description": "Ar tikrai norite ištrinti nepaskelbtas išleidimo pastabas?",
    "delete users": "Ištrinti naudotojus?",
    "delete vehicles": "Ištrinti transportus?",
    "description": "Aprašymas (neprivaloma)",
    "description not valid": "Aprašyme negali būti daugiau nei {{maxNumber}} simbolių",
    "description required": "Aprašymas",
    "description should not be empty": "Aprašymas neturi būti tuščias",
    "device imei": "Įrenginio IMEI",
    "dialog description": {
      "create company description": "Didžiausias leidžiamas įmonių lygmenų skaičius įmonių medžio struktūroje yra {{maxNumber}}.",
      "create new hierarchy description": "Didžiausias leidžiamas įmonių lygmenų skaičius įmonių medžio struktūroje yra {{maxNumber}}. Pasirinkite, ar norite sukurti naują pavaldžiąją įmonę šioje hierarchijoje, ar sukurti naują klientą naudodami kliento LZ kodą."
    },
    "download activities": "Atsisiuntimo veiksmai",
    "download blocked message": "Atsisiuntimas užblokuotas - kreipkitės į savo paslaugų teikėją, kad išspręstumėte šią problemą.",
    "download data types": "Atsisiunčiamų duomenų tipai",
    "download drivers files": "Atsisiųsti vairuotojų failus",
    "download history dialog title": "{{vehicleNumber}} istorija",
    "download monitoring dialog tooltip": "Visi šiame lange esantys duomenys automatiškai atnaujinami kas <strong>10 sekundžių</strong>.\nĮrenginio būsena atspindi paskutinį prisijungimą, o ne dabartinę transporto priemonės būseną.",
    "download only selection": "Bus atsisiųsti tik pasirinkti failai.",
    "download sample file message": "Atsisiųskite <1>pavyzdinį CSV šabloną</1>, kad pamatytumėte reikalaujamo formato pavyzdį.",
    "download status banners": {
      "CompanyCardExpired": "Įmonės kortelės galiojimo laikas pasibaigęs. Prašome įdėti galiojančią įmonės kortelę.",
      "InsufficientCredits": "Nepakanka kreditų. Norėdami atsisiųsti failus, įsigykite kreditų.",
      "NoCompanyCards": "Norint pradėti atsisiuntimą, įmonės kortelė turi būti aktyvi. Šiuo metu aktyvių kortelių nėra.",
      "NoSchedulesApplied": "Šiam transportui netaikomi jokie tvarkaraščiai.",
      "VehicleDeactivated": "Ši transportas deaktyvuota ir negali pradėti atsisiuntimo proceso."
    },
    "download status dialog title": "Atsisiuntimo stebėjimas {{vehicleNumber}}",
    "download vehicles files": "Parsisiųsti transportų failus",
    "driver file destination": "Vairuotojo failų saugojimo vieta",
    "driver file destination tooltip": "Pasirinkite, ar vairuotojo failai bus išsaugoti toje transporto aplanke, iš kurios jie buvo atsisiųsti, ar atskiruose vairuotojų aplankuose pagal vairuotojo identifikatorių.",
    "driver folder": "Vairuotojo aplankas",
    "driver id": "Vairuotojo ID",
    "driver id not valid": "Vairuotojo ID turi būti sudarytas iš {{maxNumber}} raidžių ir skaičių",
    "driver id placeholder": "Pvz.: 360896050032309",
    "driver id should not be empty": "Vairuotojo ID laukelis neturi būti tuščias",
    "driver name": "Vairuotojo vardas",
    "drivers folder naming": "Vairuotojų aplankų pavadinimai",
    "edit company": "Redaguoti įmonę „{{name}}“",
    "edit driver": "Redaguoti vairuotoją „{{name}}“",
    "edit news": "Redaguoti naujieną",
    "edit release notes tooltip": "Šios naujienos pateikiamos kaip išleidimo pastabos ir negali būti keičiamos.",
    "edit user": "Redaguoti naudotoją",
    "edit vehicle": "Redaguoti transportą „{{name}}“",
    "edit vehicle imei in use accessible": {
      "description": "Šis IMEI jau priskirtas kitai transportui. Galite pasirinkti, ar norite pakeisti IMEI tarp dviejų transportų, ar perrašyti IMEI.",
      "title": "IMEI jau naudojamas"
    },
    "email": "El. paštas",
    "endpoint url": "Galutinio taško URL",
    "endpoint url not valid": "Galutinio taško URL adresas yra neteisingas",
    "endpoint url placeholder": "Įveskite URL adresą",
    "endpointUrl": "Galutinio taško URL",
    "enter": "Įvesti",
    "enter company card id": "Įveskite įmonės kortelės identifikatorių, kurį rasite programėlėje Company Card Authenticator.",
    "enter here": "Įveskite čia",
    "enter name": "Įveskite vardą",
    "enter password": "Įveskite slaptažodį",
    "enter username": "Įveskite naudotojo vardą",
    "expiration date optional": "Galiojimo pabaigos data (neprivaloma)",
    "export drivers": {
      "description": "Eksportuokite visus pasirinktos įmonės vairuotojus į reikiamus .csv failus.",
      "include drivers from all companies": "Įtraukti visų įmonių vairuotojus",
      "title": "Vairuotojų eksportavimas"
    },
    "export vehicles": {
      "description": "Eksportuokite visus pasirinktos įmonės transportus į reikiamus .csv failus.",
      "include vehicles from all companies": "Įtraukti visų įmonių transportus",
      "title": "Transportų eksportas"
    },
    "feature switches": {
      "feature switches": "Funkcijų perjungimas",
      "toggle integrations page": "Įjungti integracijų puslapį"
    },
    "field cannot be changed": "Šio lauko negalima keisti",
    "field cannot be empty": "{{fieldName}} negali būti tuščias",
    "field length not valid": "Šiame laukelyje negali būti daugiau nei {{maxNumber}} simbolių",
    "file format": "Failo formatas",
    "filtered resource": "Filtruota {{resource}}",
    "filtered drivers": "Filtruoti vairuotojai",
    "filtered vehicles": "Filtruotas transportas",
    "from": "Iš",
    "future dates": {
      "1 day": "už 1 dienos",
      "1 minute": "už 1 minutės",
      "1 month": "už 1 mėnesio",
      "1 week": "už 1 savaitės",
      "1 year": "už 1 metų",
      "hours and minutes": "už {{hourCount}} val. {{minutesCount}} min.",
      "less than a minute": "už <1 minutės",
      "multiple days": "už {{daysCount}} dienų",
      "multiple minutes": "už {{minutesCount}} minučių",
      "multiple months": "už {{monthsCount}} mėnesių",
      "multiple weeks": "už {{weeksCount}} savaičių",
      "multiple years": "už {{yearsCount}} metų"
    },
    "generate api key": {
      "title": "Sukurti API raktą"
    },
    "host": "Pagrindinis serveris",
    "host cannot contain more than": "Vardas negali būti ilgesnis nei {{maxNumber}} simbolių",
    "imei": "IMEI",
    "imei not valid": "IMEI turėtų būti sudarytas iš {{maxNumber}} skaitmenų",
    "imei placeholder": "Pvz.: 360896050032309",
    "imei should not be empty": "IMEI laukelis neturi būti tuščias",
    "import drivers": "Vairuotojų importavimas",
    "import drivers description": "Pridėkite vairuotojus į savo sąrašą, importuodami juos iš failo.",
    "import vehicles": "Importuojamos transporto",
    "import vehicles description": "Pridėkite transportus į savo sąrašą, importuodami jas iš failo.",
    "integration name": "Integracijos pavadinimas",
    "integration type": "Integracijos tipas",
    "integrations": {
      "deactivate api key": "API rakto deaktyvavimas",
      "deactivate integration tooltip": "Laikinai išjunkite integraciją. Galite ją vėl įjungti, pašalinant žymę iš šio pasirinkimo.",
      "deactivate integration": {
        "title": "Išjungti šią integraciją",
        "tooltip": "Laikinai išjunkite integraciją. Norėdami ją vėl įjungti, pašalinkite žymę iš šios parinkties."
      },
      "deactivate sftp": "Išjungti SFTP",
      "disable integration": {
        "description": "Ar tikrai norite išjungti integraciją „{{integrationName}}“?",
        "title": "Išjungti integraciją?"
      },
      "driver files info banner": "Atkreipkite dėmesį, kad iki {{formattedDate}} atsisiųsti vairuotojo failai bus įkelti į paskutinio vairuotojo vairuoto transporto aplanką. ",
      "errors": {
        "AuthenticationFailed": {
          "description": "Prašome įsitikinti, kad naudotojo vardas ir slaptažodis įvesti teisingai.\nIntegracija bus išsaugota su būsena „Nepavyko“, kol nebus įvesti teisingi prisijungimo duomenys.",
          "title": "Neteisingi prisijungimo duomenys."
        },
        "FolderCreationFailed": {
          "description": "TachoSync prijungtas prie serverio, tačiau neturi leidimo kurti aplankų ar įkelti failų į paskirties katalogą.\nIntegracija bus išsaugota su būsena „Nepavyko“, kol problema bus išspręsta ir bandysite prisijungti iš naujo.",
          "title": "Trūksta rašymo teisių."
        },
        "HostUnreachable": {
          "description": "Prašome įsitikinti, kad serverio adresas ir prievadas yra teisingi, o serveris veikia.\nIntegracija bus išsaugota su būsena „Nepavyko“, kol problema bus išspręsta ir bandysite prisijungti dar kartą.",
          "title": "Negaliu prisijungti prie serverio."
        },
        "PathNotFound": {
          "description": "Nurodyto katalogo serveryje rasti nepavyko. Patikrinkite, ar kelias nurodytas teisingai.\nIntegracija bus išsaugota su būsena „Nepavyko“, kol nebus nurodytas teisingas kelias.",
          "title": "Kelias nerastas."
        },
        "PermissionDenied": {
          "description": "Prašome įsitikinti, kad TachoSync turi reikiamus leidimus pasiekti šį katalogą.\nIntegracija bus išsaugota su būsena „Nepavyko“, kol nebus atnaujinti leidimai ir jūs vėl nepabandysite prisijungti.",
          "title": "Prieiga prie kelio uždrausta."
        },
        "Unknown": {
          "description": "Bandant prisijungti prie SFTP serverio, įvyko netikėta problema. Patikrinkite savo serverio duomenis ir nustatymus.\nIntegracija bus išsaugota su būsena „Nepavyko“, kol problema nebus išspręsta ir jūs vėl nepabandysite prisijungti.",
          "title": "Įvyko netikėta klaida."
        }
      },
      "include files from all sub companies": "Įtraukti visų dukterinių įmonių failus",
      "include files tooltip": "Pasirinkus šią integraciją, taip pat bus atsisiunčiami failai iš visų jūsų paskyrai priklausančių dukterinių įmonių",
      "include historical files": "Įtraukti istorinius failus",
      "include historical files tooltip": "Jei pasirinksite šią parinktį, taip pat bus atsisiųsti failai, atsisiųsti prieš sukuriant šią integraciją.",
      "select driver files destination": "Pasirinkite vairuotojo failų paskirties vietą"
    },
    "introduce name": "Įveskite vardą",
    "invite user": "Pakviesti naudotoją",
    "invite user description": "Išsiuntus kvietimą, naudotojas gaus \nel. laišką su nuoroda paskyrai sukurti. Nuoroda galioja 7 dienas.",
    "invite user sent": "Naudotojo kvietimas sėkmingai išsiųstas.",
    "loading": "Įkeliama...",
    "make release notes": "Sukurti išleidimo pastabas",
    "make release notes info": "Jei šis laukelis pažymėtas, naujienos bus paskelbtos skyriuje „Išleidimo pastabos“, o pavadinimas bus pakeistas į „Išleidimo pastabos“.",
    "max download files": "Didžiausias leidžiamas failų skaičius vienam atsisiuntimui – {{maxNumber}}.",
    "move company": {
      "confirmation dialog": {
        "are you sure": "Ar esate tikri?",
        "description": "Jūs ketinate perkelti „{{sourceCompany}}“ į „{{targetCompany}}“. Šis veiksmas yra negrįžtamas, ar tikrai norite tęsti?"
      },
      "description": "Pasirinkite šaltinio įmonę ir paskirties įmonę, į kurią norite ją perkelti. Šaltinio įmonė ir jos ištekliai bus perkelti į pasirinktą paskirties įmonę. Šis veiksmas yra negrįžtamas.",
      "error dialog": {
        "description": "Didžiausias leidžiamas įmonių skaičius – 4. Perkelus čia pasirinktą įmonę, šis limitas būtų viršytas.",
        "title": "Įmonės perkelti negalima"
      },
      "info banner": "Šaltinio įmonė išlaikys visus savo transportus, vairuotojus, failus, įmones, naudotojus, integracijas ir individualius tvarkaraščius. Jei pagrindinės įmonės lygmenyje įjungtas bendras tvarkaraštis, jis bus perimtas po perkėlimo. Jei ne, esami tvarkaraščiai išliks tokie, kokie yra.",
      "sftp warning": "Pasirinktoje įmonėje yra sukonfigūruotas veikiantis SFTP serveris. SFTP ryšys bus sustabdytas, kol vyks įmonės perkėlimas. Baigus perkėlimą, bus sukurtas naujas SFTP kelias ir ryšys bus atnaujintas.",
      "source company": "Šaltinio įmonė",
      "target company": "Tikslinė įmonė",
      "title": "Perkelti įmonę"
    },
    "move vehicles": "Perkelti transportus",
    "move vehicles info": "Pastaba: Transportų failai liks dabartinėje įmonėje. Atsisiuntimo istorija bus ištrinta, o atsisiuntimo tvarkaraščiai – pašalinti.",
    "name": "Pavadinimas",
    "name not valid": "Vardas negali būti ilgesnis nei {{maxNumber}} simbolių",
    "name should not be empty": "Vardas neturi būti tuščias",
    "name too short": "Vardas turi būti sudarytas iš ne mažiau kaip {{minNumber}} simbolių",
    "optional": "pasirinktinai",
    "overwrite imei checkbox": {
      "description": "Pasirinkus šią parinktį, IMEI bus pašalintas iš {{vehicleNumber}}.",
      "title": "IMEI perrašymas."
    },
    "parent company": "Motininė įmonė",
    "password": "Slaptažodis",
    "password cannot contain more than": "Slaptažodis negali būti ilgesnis nei {{maxNumber}} simbolių",
    "past dates": {
      "1 month ago": "Prieš 1 mėnesį",
      "1 week ago": "Prieš 1 savaitę",
      "1 year ago": "Prieš 1 metus",
      "multiple months ago": "Prieš {{monthCount}} mėnesius",
      "multiple weeks ago": "Prieš {{weekCount}} savaites",
      "multiple years ago": "Prieš {{yearCount}} metus",
      "today": "Šiandien",
      "yesterday": "Vakar"
    },
    "port": "Uostas",
    "port must be between": "Portas turi būti tarp verčių {{minNumber}} ir {{maxNumber}}",
    "previous month": "Praėjusį mėnesį",
    "provider": "Teikėjas",
    "publish news": "Publikuoti naujienas?",
    "publish news description": "Ši naujiena bus paskelbta. Ar tikrai norite tęsti? Šio veiksmo negalima atšaukti.",
    "publish release notes": "Ar skelbti išleidimo pastabas?",
    "publish release notes description": "Paskelbimo pastabos bus paskelbtos. Ar tikrai norite tęsti? Šio veiksmo negalima atšaukti.",
    "release notes": "Atnaujinimo pastabos",
    "remote directory path cannot contain more than": "Nuotolinio katalogo kelias negali būti ilgesnis nei {{maxNumber}} simbolių",
    "remote directory path optional": "Nuotolinio katalogo kelias (neprivaloma)",
    "remove": "Pašalinti",
    "remove schedules": "Pašalinti tvarkaraščius",
    "remove schedules confirmation description": {
      "drivers multiple": "Ar tikrai norite pašalinti {{resourceValue}} tvarkaraščius iš pasirinktų vairuotojų?",
      "drivers single": "Ar tikrai norite pašalinti {{resourceValue}} iš pasirinktų vairuotojų?",
      "vehicles multiple": "Ar tikrai norite pašalinti {{resourceValue}} tvarkaraščius iš pasirinktų transportų?",
      "vehicles single": "Ar tikrai norite pašalinti {{resourceValue}} iš pasirinktų transportų?"
    },
    "remove schedules description": {
      "drivers": "Pasirinkite vieną ar kelis tvarkaraščius, kuriuos norite pašalinti iš pasirinktų vairuotojų.",
      "vehicles": "Pasirinkite vieną ar daugiau tvarkaraščių, kuriuos norite pašalinti iš pasirinktų transportų."
    },
    "resend invitation": "Pakartotinai išsiųsti kvietimą",
    "resend invitation description": "Ar tikrai norite iš naujo išsiųsti kvietimą dėl {{userEmail}}?",
    "role": "Pareigos",
    "schedule apply to all": {
      "drivers": "Pasirinktas tvarkaraštis bus taikomas visiems pasirinktos įmonės vairuotojams.",
      "vehicles": "Pasirinktas tvarkaraštis bus taikomas visoms pasirinktos įmonės transporto priemonėms."
    },
    "schedule apply to filtered": {
      "drivers": "Pasirinktas tvarkaraštis bus taikomas vairuotojams, atrinktiems naudojant vieną ar kelis galimus filtrus.",
      "vehicles": "Pasirinktas tvarkaraštis bus taikomas transporto priemonėms, atrinktoms naudojant vieną ar kelis galimus filtrus."
    },
    "schedule apply to selected": {
      "drivers": "Pasirinktas tvarkaraštis bus taikomas visiems pažymėtiems vairuotojams.",
      "vehicles": "Pasirinktas tvarkaraštis bus taikomas visoms pažymėtoms transporto priemonėms."
    },
    "schedule time tooltip description": "Jei pasirinktas laikas yra praeityje, sistema jį automatiškai pakoreguos iki artimiausio galimo laiko ateityje.",
    "security settings": "Saugumo nustatymai",
    "security settings description": "Raskite parinktis, kurios leidžia jums kontroliuoti, kaip apsaugoma jūsų paskyra.",
    "select": "Pasirinkite",
    "select a company": "Pasirinkite įmonę",
    "select file format example": "Pasirinkite formatą (pvz., .DDD)",
    "select format": "Pasirinkite formatą",
    "select image": "Pasirinkite paveikslėlį",
    "select image description": "Pasirinkite norimą naudoti paveikslėlį, spustelėję jį ir paspaudę mygtuką „Išsaugoti“.",
    "select schedules": "Pasirinkite tvarkaraščius",
    "selected resource": "Pasirinkta {{resource}}",
    "selected drivers": "Pasirinkti vairuotojai",
    "selected vehicles": "Pasirinktas transportas",
    "selected role info message": "<3>Spauskite čia</3>, kad peržiūrėtumėte išsamią teisių lentelę.",
    "selected role info message title": "Naudotojo vaidmuo lems jo teises programoje TachoSync.",
    "sftp integration": {
      "description": "Nustatykite SFTP ryšį ir apibrėžkite, kaip bus struktūrizuoti tachografo failai.",
      "edit title": "Redaguoti SFTP integraciją „{{integrationName}}“",
      "sftp name": "SFTP pavadinimas",
      "title": "SFTP integracija"
    },
    "sftp password": "SFTP slaptažodis",
    "sftp server hostname or ip": "SFTP serverio vardas arba IP adresas",
    "sftp server port number": "SFTP serverio prievado numeris",
    "sftp server settings": "SFTP serverio nustatymai",
    "sftp username": "SFTP naudotojo vardas",
    "Teltonika code": "Teltonika kodas",
    "Teltonika code invalid characters": "Teltonika kodas turi būti {{minCount}}–{{maxCount}} simbolių ilgio ir gali būti sudarytas iš raidžių, skaičių ir taškų.",
    "Teltonika code placeholder": "Teltonika kodas turi būti {{minCount}}–{{maxCount}} simbolių ilgio",
    "Teltonika company name": "Įmonės pavadinimas",
    "time": "Laikas",
    "time zone": "Laiko juosta",
    "title": "Pavadinimas",
    "title not valid": "Pavadinime negali būti daugiau nei {{maxNumber}} simbolių",
    "title should not be empty": "Pavadinimas neturi būti tuščias",
    "title too short": "Pavadinime turi būti ne mažiau kaip {{minNumber}} simbolių",
    "to": "Į",
    "toggle children global schedule linking": "Prijungta prie pagrindinės įmonės Bendras tvarkaraštis",
    "toggle children global schedule linking tooltip": "Pagrindinė įmonė įgalino bendrojo tvarkaraščio perėmimą. Norėdami redaguoti pasirinktos įmonės bendrąjį tvarkaraštį, išjunkite šią parinktį. Atkreipkite dėmesį, kad tai atjungs bendrąjį tvarkaraštį nuo pagrindinės įmonės.",
    "toggle global schedule linking": "Taikyti bendrą tvarkaraštį visoms dukterinėms įmonėms",
    "toggle global schedule linking tooltip": "Įjungus šią parinktį, bendrasis tvarkaraštis bus taikomas visoms dukterinėms įmonėms. Dukterinės įmonės gali išjungti šią parinktį, kad galėtų pritaikyti savo bendrąjį tvarkaraštį.",
    "toggle global schedule warning banner": "Kai kurios dukterinės įmonės galbūt jau naudoja kitą bendrą tvarkaraštį. Ši parinktis neturės įtakos joms, nebent jos ją pasirinks savo bendro tvarkaraščio nustatymuose.",
    "unpublished release notes": "Yra nepaskelbtos versijos pastabos.",
    "upload folder blank for root": "Įkėlimo aplankas (tuščias, jei esate pagrindiniame kataloge)",
    "username": "Naudotojo vardas",
    "username cannot contain more than": "Naudotojo vardas negali būti ilgesnis nei {{maxNumber}} simbolių",
    "vdo integration": {
      "add": {
        "description": "Nustatykite savo VDO transporto parko ryšį.",
        "title": "Pridėti VDO transporto parko integraciją"
      },
      "edit": {
        "description": "Nustatykite savo VDO transporto parko ryšį.",
        "title": "Redaguoti VDO transporto parko integraciją"
      },
      "provider settings description": "Būtinai naudokite VDO Fleet pateiktus prisijungimo duomenis.",
      "provider settings title": "Tiekėjo nustatymai"
    },
    "vehicle folder": "Transporto aplankas",
    "vehicle imei in use inaccessible": {
      "description": "Šis IMEI jau priskirtas įmonei, nepriklausančiai jūsų įmonių grupei. Jei prietaisas su šiuo IMEI priklauso jums, kreipkitės į <supportLink>Teltonika pagalbos tarnybą</supportLink>.",
      "title": "IMEI, kurį naudoja kita įmonių grupė"
    },
    "vehicle name": "Transporto pavadinimas",
    "vehicle number": "Transporto registracijos numeris (VRN)",
    "vehicle registration number tooltip": "Jūsų įmonės nustatymuose įjungtas automatinis atnaujinimas. Čia įvestas VRN numeris bus pakeistas verte, nuskaityta iš tachografo duomenų po pirmojo sėkmingo atsisiuntimo.",
    "vehicles folder naming": "Transportų aplankų pavadinimai",
    "vrn": "VRN",
    "vrn should not be empty": "Transporto registracijos numeris neturi būti tuščias",
    "welcome to beta version title": "Sveiki atvykę į TachoSync BETA testavimą!"
  },
  "Download history": {
    "download successful": "Atsisiuntimas sėkmingas",
    "driver data": "Vairuotojų duomenys",
    "no history": "Čia bus rodoma istorija",
    "schedule": "Tvarkaraštis"
  },
  "Download monitoring": {
    "APDU packet reading error. Device disconnected.": "APDU paketo skaitymo klaida. Įrenginys atjungtas.",
    "Authenticating": "Autentifikavimas",
    "Authentication failure (02x10)": "Autentifikavimo klaida (02x10)",
    "Authentication failure after timeout (02x01)": "Autentifikavimo klaida pasibaigus laiko limitui (02x01)",
    "Authentication failure after timeout (02x12)": "Autentifikavimo klaida pasibaigus laiko limitui (02x12)",
    "Card reading error. Please reinsert the company card, reconnect the card reader, or restart the service.": "Kortelės skaitymo klaida. Įdėkite įmonės kortelę iš naujo, vėl prijunkite kortelių skaitytuvą arba iš naujo paleiskite paslaugą.",
    "CheckingCredits": "Kreditų tikrinimas",
    "CompanyCardExpired": "Įmonės kortelės galiojimo laikas pasibaigęs",
    "CompanyCardInUse": "Naudojama įmonės kortelė",
    "Could not download any of files": "Nepavyko atsisiųsti nė vieno failo",
    "CreditReserved": "Kreditai rezervuoti",
    "Download rejected: device VIN doesn't match this vehicle's VIN record. If the device was moved to a new vehicle, create a new vehicle record to continue.": "Atsisiuntimas atmestas: prietaiso VIN nesutampa su šio automobilio VIN įrašu. Jei prietaisas buvo perkeltas į kitą automobilį, sukurkite naują automobilio įrašą, kad galėtumėte tęsti.",
    "DownloadingDriverData": "Vairuotojų duomenų atsisiuntimas",
    "DownloadingDriverDataFailed": "Nepavyko atsisiųsti vairuotojo duomenų",
    "DownloadingVehicleData": "Transportų duomenų atsisiuntimas",
    "Driver info packet reading error. Device disconnected.": "Klaida skaitant vairuotojo informacijos paketą. Įrenginys atjungtas.",
    "Failed to download driver data": "Nepavyko atsisiųsti vairuotojo duomenų",
    "Failed to receive APDU from card, timeout exceeded": "Nepavyko gauti APDU iš kortelės, viršytas laiko limitas",
    "Failed to receive VUReady packet from device, timeout exceeded": "Nepavyko gauti VUReady paketo iš įrenginio, viršytas laiko limitas",
    "Failed to receive VUReady packet. If problem persists, check the telematics/tacho devices setup.": "Nepavyko gauti VUReady paketo. Jei problema neišsprendžiama, patikrinkite telematikos / tachografų įrenginių nustatymus.",
    "InsufficientCredits": "Nepakankamas kreditų kiekis",
    "Lost connection with device or card": "Prarastas ryšys su įrenginiu arba kortele",
    "NoCompanyCards": "Nėra įmonės kortelių",
    "NoDueSchedules": "Nėra nustatytų terminų",
    "NoSchedulesApplied": "Tvarkaraščiai netaikomi",
    "ProcessTerminated": "Procesas nutrauktas",
    "ReceivingDownloadList": "Atsisiuntimo sąrašo gavimas",
    "ReceivingDriverInfo": "Vairuotojo informacijos gavimas",
    "ReceivingDriversSchedules": "Vairuotojų tvarkaraščių gavimas",
    "ReceivingStatusState": "Prieigos būsenos gavimas",
    "ReceivingVehicleSchedules": "Transportų tvarkaraščių gavimas",
    "requirements": {
      "company card": "Įmonės kortelė",
      "credits available": "Prieinami kreditai",
      "ignition": "Užkūrimas",
      "ignition unavailable tooltip": "Nežinoma - paskutinė žinoma būsena buvo prieš daugiau nei 2 valandas.",
      "imei": "IMEI",
      "schedule assigned": "Tvarkaraštis priskirtas",
      "vehicle activated": "Transporto priemonė aktyvuota",
      "reason": {
        "CompanyCardExpired": "Įmonės kortelės galiojimo laikas baigėsi",
        "IgnitionNotReportedRecently": "Nežinoma būsena - apie užkūrimo būseną pastaruoju metu nebuvo pranešta. Atsisiuntimas vis tiek bus bandomas, tačiau tikimybė, kad pavyks, yra mažesnė",
        "IgnitionOff": "Užkūrimas išjungtas. Atsisiuntimas vis tiek bus bandomas, tačiau tikimybė, kad pavyks, yra mažesnė",
        "InsufficientCredits": "Nėra prieinamų kreditų",
        "NoCompanyCardOnline": "Nė viena įmonės kortelė nėra prisijungusi",
        "NoCompanyCards": "Nė viena įmonės kortelė nėra prisijungusi",
        "NoImeiAssigned": "Transportui nėra priskirtas IMEI",
        "NoScheduleAssigned": "Transportui turi būti priskirtas tvarkaraštis",
        "VehicleDeactivated": "Norint atsisiųsti duomenis, transporto priemonė turi būti aktyvuota"
      }
    },
    "schedules": {
      "assign schedules": "Tvarkaraščių priskyrimas",
      "assign schedules dialog": {
        "description": "Pasirinkite vieną ar daugiau tvarkaraščių, kuriuos norite priskirti.",
        "title": "Paskirti tvarkaraščius {{vehicleNumber}}"
      },
      "fail reason": {
        "download requirements not met": "atsisiuntimo reikalavimai neįvykdyti."
      },
      "no schedules assigned": "Šiam transportui nėra priskirti jokie tvarkaraščiai",
      "on device connection": "prisijungus prie įrenginio",
      "requirements not met": "Tvarkaraštis negali būti vykdomas, kol nebus įvykdyti visi reikalavimai."
    },
    "StageComplete": "Etapas baigtas",
    "Stages": {
      "Authentication": "Autentifikavimas",
      "Downloading": "Atsisiuntimas",
      "DownloadTrigger": "Atsisiuntimo trigeris",
      "Initialization": "Inicijavimas"
    },
    "Status packet reading error. Device disconnected.": "Klaida skaitant būsenos paketą. Įrenginys atjungtas.",
    "TerminatingConnectionToDevice": "Ryšio su įrenginiu nutraukimas",
    "Timeout. Response from VU not received (02x01)": "Laiko limitas pasibaigęs. Negautas atsakymas iš VU (02x01)",
    "Too many KeepAlive packets received.": "Gauta per daug „KeepAlive“ paketų.",
    "Unexpected error": "Nenumatyta klaida",
    "Unexpected loss of connection with the device. Once device returns to normal connectivity, download will continue.": "Netikėtas ryšio su įrenginiu nutrūkimas. Kai įrenginys vėl prisijungs, atsisiuntimas bus tęsiamas.",
    "UploadingDriverFiles": "Vairuotojų failų įkėlimas",
    "UploadingDriverFilesFailed": "Nepavyko įkelti vairuotojų failų",
    "UploadingVehicleFiles": "Transportų failų įkėlimas",
    "UploadingVehicleFilesFailed": "Nepavyko įkelti transporto failų",
    "VehicleDeactivated": "Transportas deaktyvuotas",
    "VuNotReady": "VU neparuoštas. Bandysime dar kartą po 5 min.",
    "VU ready packet reading error. Device disconnected.": "VU parengto paketo skaitymo klaida. Įrenginys atjungtas.",
    "WaitingForDeviceConnection": "Laukiama prietaiso prisijungimo",
    "Wrong communication command": "Neteisinga ryšio komanda"
  },
  "Drivers": {
    "drivers page": "Vairuotojai",
    "last activity": {
      "Available": "Pasiekiama",
      "BreakOrRest": "Pertrauka/Poilsis",
      "Drive": "Vairavimas",
      "NotAvailable": "Nėra",
      "Undefined": "N/A",
      "Unknown": "Nežinoma",
      "Unknown4": "Nežinoma",
      "Unknown5": "Nežinoma",
      "Work": "Darbas"
    }
  },
  "Dropzone": {
    "add file": "Pridėti failą",
    "drop file to upload": "Norėdami įkelti failą, meskite jį čia",
    "drop files to upload": "Norėdami įkelti failus, juos meskite į šią vietą",
    "error uploading the file": "Įkeliant failą įvyko klaida",
    "file invalid type": "Pasirinkta netinkama failo rūšis.",
    "file syntax": "Failo sintaksė yra tokia:",
    "file successfully uploaded": "Failas sėkmingai įkeltas",
    "maximum file limit reached": "Pasiektas maksimalus failų dydžio limitas.",
    "no image": "Nuotraukos nėra",
    "only one file can be attached": "Galima pridėti tik vieną failą.",
    "or drop file to upload": "Arba įkelkite failą, jį įtraukdami",
    "or drop files to upload": "Arba perkelkite failus, kad juos įkeltumėte",
    "row limit exceeded": "Pasiektas išteklių importo limitas. Negalima importuoti daugiau nei {{rowLimit}} išteklių.",
    "rows detected": "Failo eilutės sėkmingai aptiktos",
    "select file": "Pasirinkite failą",
    "select file type": "Pirmiausia pasirinkite failo tipą.",
    "select files": "Pasirinkite failus",
    "select image": "Pasirinkite paveikslėlį:",
    "supported formats": "Palaikomi formatai",
    "too long file name": "Failo pavadinimas per ilgas. Leidžiamas maksimalus simbolių skaičius – {{maxLength}}.",
    "too many files description": "Likusius failus galėsite įkelti po to, kai įkelsite pasirinktus failus.",
    "too many files title": "Vienu metu galite pridėti ne daugiau kaip {{maxFiles}} failų."
  },
  "Error": {
    "error": "Klaida",
    "message wait": "Prašome kantriai laukti, kol ištaisysime šią klaidą.",
    "title": "Kilo klaida!"
  },
  "Files": {
    "files header info tooltip": "Atsisiųsti failai saugomi TachoSync sistemoje dvejus metus, po to jie automatiškai pašalinami iš sistemos."
  },
  "Filter": {
    "company": "Įmonė",
    "credit status": "Kredito būklė",
    "deactivatedVehicles": "Deaktyvuotas transportas",
    "device imei": "Įrenginio IMEI",
    "device status": "Įrenginio būsena",
    "driver": "Vairuotojas",
    "filtered by": "Filtruota pagal",
    "filters used": "Naudojami filtrai",
    "from to date": "{{fromDate}} iki {{toDate}}",
    "last activity": "Paskutinė veikla",
    "last download": "Paskutinis atsisiuntimas",
    "last download options": {
      "DueSoon": "Netrukus",
      "NoDownloads": "Nėra atsisiuntimų",
      "OnTime": "Laiku",
      "Overdue": "Vėluojama",
      "Undefined": "Netaikoma"
    },
    "more filters": "Daugiau filtrų",
    "noDeviceImei": "Nėra įrenginio IMEI",
    "Not reserved": "Nėra rezervuota",
    "Reserved": "Rezervuota",
    "schedule": "Tvarkaraštis",
    "schedule name": "Tvarkaraščio pavadinimas",
    "schedules": "Tvarkaraščiai",
    "select date": "Pasirinkite datą",
    "select date and time": "Pasirinkite datą ir laiką",
    "Select date range": "Pasirinkite datų intervalą",
    "status": "Būklė",
    "table filters": "Lentelės filtrai",
    "vehicle number": "Transporto numeris"
  },
  "General": {
    "Active": "Aktyvus",
    "Administrator": "Administratorius",
    "administrator role description": "Visos teisės kurti, redaguoti ir trinti visus išteklius.",
    "analysis provider": "Analizės teikėjas",
    "analysis providers": "Analizės teikėjai",
    "api credential": "API prisijungimo duomenys",
    "api credentials": "API prisijungimo duomenys",
    "Available": "Prieinama",
    "Awaiting connection": "Laukiama prisijungimo",
    "badge": {
      "connected badge tooltip text": "Sėkmingai prisijungta prie TachoSync ir vyksta aktyvus ryšys.",
      "deactivated badge tooltip text": "Ši transportas deaktyvuotas ir nebus naudojami kreditai.",
      "inactive badge tooltip text": "Niekada nepavyko užmegzti ryšio su TachoSync.",
      "offline badge tooltip text": "Per pastarąsias 24 valandas nebuvo prisijungta prie TachoSync",
      "online badge tooltip text": "Prisijungė per pastarąsias 24 valandas"
    },
    "Blocked": "Užblokuota",
    "BreakOrRest": "Pertrauka / Poilsis",
    "business": "Verslas",
    "code expired": "Jūsų prisijungimo sesija pasibaigė. Prašome prisijungti iš naujo.",
    "column": "Stulpelis",
    "company": "Įmonė",
    "Company administrator": "Įmonės administratorius",
    "companies": "Įmonės",
    "Connected": "Prijungta",
    "credits": "Kreditas",
    "dashboard": "Pagrindinis puslapis",
    "Deactivated": "Deaktyvuota",
    "Description": "Aprašymas",
    "Disabled": "Išjungta",
    "Disconnected": "Atsijungta",
    "Drive": "Vairavimas",
    "driver data": "Vairuotojų duomenys",
    "drivers": "Vairuotojai",
    "DueSoon": "Netrukus",
    "end": "Pabaiga",
    "Expired": "Pasibaigęs galiojimo laikas",
    "Failed": "Nepavyko",
    "files": "Failai",
    "here": "čia",
    "history": "Istorija",
    "year": "Metai",
    "Inactive": "Neaktyvus",
    "in progress": "vykdoma",
    "integration": "Integracija",
    "integrations": "Integracijos",
    "integrations/analysisProviders": "Analizės teikėjai",
    "integrations/apicredentials": "API prisijungimo duomenys",
    "Interrupted": "Pertraukta",
    "InvalidConfiguration": "Nepavyko",
    "invitations": "Kvietimai",
    "latest version": "Naujausia versija",
    "menu": "Meniu",
    "NoDownloads": "Nėra atsisiuntimų",
    "not assigned": "Nepaskirta",
    "Not reserved": "Nerezervuota",
    "NotAvailable": "Neprienama",
    "NotReserved": "Nerezervuota",
    "Offline": "Neprisijungta",
    "Online": "Pasiekiama",
    "OnTime": "Laiku",
    "Pending": "Laukiama",
    "requirements": "Reikalavimai",
    "Reserved": "Rezervuota",
    "row": "Eilutė",
    "schedule": "Tvarkaraštis",
    "schedules": "Tvarkaraščiai",
    "show older": "Rodyti senesnius",
    "start": "Pradėti",
    "Successful": "Sėkmingas",
    "Teltonika support": "Teltonika pagalba",
    "Teltonika Support": "Teltonika pagalba",
    "teltonika support role description": "Specializuota prieiga techninei pagalbai.",
    "Tooltip": {
      "accept beta terms": "Norėdami tęsti, nuslinkite į puslapio apačią ir sutikite su sąlygomis."
    },
    "unauthorized": "Nepavyko patvirtinti naudotojo tapatybės",
    "Undefined": "N/A",
    "Unknown": "Nežinoma",
    "Unknown4": "Nežinoma",
    "Unknown5": "Nežinoma",
    "User": "Naudotojas",
    "user role description": "Pagrindinė prieiga su ribotomis teisėmis.",
    "users": "Naudotojai",
    "vehicles": "Transportas",
    "Work": "Darbas"
  },
  "Languages": {
    "english": "Anglų",
    "french": "Prancūzų",
    "language": "Kalba"
  },
  "Navigation": {
    "collapse menu": "Suskleisti meniu",
    "expand menu": "Išskleisti meniu"
  },
  "News": {
    "create news": "Sukurti naujieną",
    "delete": "Ištrinti",
    "edit": "Redaguoti",
    "publish": "Publikuoti",
    "unpublished": "Neskelbta"
  },
  "Notifications": {
    "notifications": "Pranešimai"
  },
  "Password": {
    "account password": "Paskyros slaptažodis",
    "are you sure": "Ar esate tikri?",
    "change": "Pakeisti",
    "change password": "Pakeisti slaptažodį",
    "click to scan code": "Spauskite čia, jei norite nuskaityti QR kodą",
    "click to type code": "Spauskite čia, jei norite kodą įvesti rankiniu būdu",
    "disable description confirmation": "Jūs ketinate išjungti dviejų žingsnių autentifikavimą. Dėl to jūsų TachoSync paskyra gali tapti nesaugi. Ar tikrai norite tęsti?",
    "disable description send code": "Į jūsų autentifikavimo programėlę buvo išsiųstas 6 skaitmenų kodas. Saugumo sumetimais įveskite sukurtą kodą į žemiau esantį laukelį.",
    "disable description send password": "Saugumo sumetimais prašome dar kartą įvesti esamą slaptažodį.",
    "disable no access": "Jei nebeturite prieigos prie su šia paskyra susietos autentifikavimo programėlės, norint išjungti dviejų žingsnių autentifikavimą, reikia pakeisti slaptažodį.",
    "disabled": "Deaktyvuotas",
    "disabled two FA": "Dviejų žingsnių autentifikavimas sėkmingai išjungtas.",
    "enabled": "Įjungta",
    "enter": "Įvesti",
    "enter current password": "Įveskite dabartinį slaptažodį",
    "generate key description": "Norėdami užbaigti šį procesą, jums reikės mobilioji autentifikavimo programa, pavyzdžiui, viena iš šių:",
    "incorrect code": "Neteisingas kodas",
    "incorrect password": "Neteisingas slaptažodis",
    "lowercase letter": "Bent viena mažoji raidė (a-z)",
    "minimum characters": "Ne mažiau kaip {{maxNumber}} simbolių",
    "minimum digits": "Bent vienas skaitmuo",
    "password": "Slaptažodis",
    "password too long": "Slaptažodis negali būti ilgesnis nei {{maxNumber}} simbolių",
    "passwords must match": "Slaptažodžiai turi sutapti",
    "reset password success": "Jūsų slaptažodis buvo pakeistas.",
    "scan QR code": "Nuskaitykite QR kodą savo programėlėje",
    "six digit code": "Jūsų programėlės sukurtas 6 skaitmenų kodas",
    "special character": "Bent vienas specialusis simbolis (!@#$%^&*()-_=+)",
    "success description": "Jūs sėkmingai įjungėte dviejų žingsnių autentifikavimą.",
    "two-factor authentication": "Dviejų žingsnių autentifikavimas",
    "two-factor authentication description": "Dviejų žingsnių autentifikavimas – tai papildoma saugumo priemonė, kuri patvirtina jūsų tapatybę remiantis tuo, ką žinote (slaptažodžiu), ir tuo, ką turite (telefonu, saugumo raktu).",
    "two-factor authentication enabled": "Dviejų žingsnių autentifikavimas sėkmingai įjungtas.",
    "two-factor authentication status": "Dviejų žingsnių autentifikavimas – tai:",
    "type text code": "Įveskite teksto kodą į savo programėlę",
    "uppercase letter": "Bent viena didžioji raidė (A-Z)"
  },
  "Schedules": {
    "activities from": "Veiklos nuo",
    "activities to": "Veiklos iki",
    "apply button tooltip": "Pasirinkite bent vieną {{resourceName}} ir tvarkaraštį, tada spauskite „Taikyti“.",
    "confirm bulk quick schedule": "Jūs ketinate sukurti greitąjį tvarkaraštį pasirinktiems vairuotojams. Ar norite tęsti?",
    "confirm close": {
      "description": {
        "drivers": {
          "not selected": "Jūs pasirinkote vairuotojus, tačiau nebuvo pasirinktas ar pritaikytas joks tvarkaraštis. Ar tikrai norite tęsti?",
          "selected": "Jūs pasirinkote tvarkaraštį, bet jo netaikėte. Ar norite taikyti tvarkaraštį pasirinktiems vairuotojams?"
        },
        "vehicles": {
          "not selected": "Jūs pasirinkote transportus, tačiau nebuvo pasirinktas ar pritaikytas joks tvarkaraštis. Ar tikrai norite tęsti?",
          "selected": "Jūs pasirinkote tvarkaraštį, bet jo netaikėte. Ar norite taikyti tvarkaraštį pasirinktoms transportams?"
        }
      },
      "title": {
        "not selected": "Nėra pasirinktas ar pritaikytas tvarkaraštis.",
        "selected": "Tvarkaraštis netaikomas."
      }
    },
    "confirm delete": {
      "description": {
        "drivers": "Ar tikrai norite ištrinti tvarkaraštį „{{scheduleName}}“? Šis veiksmas yra negrįžtamas ir turės įtakos visiems vairuotojams, kuriems taikomas šis tvarkaraštis.",
        "vehicles": "Ar tikrai norite ištrinti tvarkaraštį „{{scheduleName}}“? Šis veiksmas yra negrįžtamas ir turės įtakos visoms transportams, kurioms taikomas šis tvarkaraštis."
      },
      "title": "Ištrinti tvarkaraštį?"
    },
    "create new schedule": "Sukurti naują tvarkaraštį",
    "days": "dienos",
    "data types": "Duomenų tipai",
    "details remove schedule": {
      "description": "Ar tikrai norite pašalinti tvarkaraštį „{{scheduleName}}“?",
      "title": "Pašalinti tvarkaraštį?"
    },
    "download activities": {
      "date info tooltip": "Veiklos laikotarpis turi apimti bent dvi dienas.",
      "tooltip text": "TachoSync naudoja prisitaikantį veiklos duomenų atsisiuntimo intervalą, užtikrinantį nepertraukiamumą, automatiškai koreguodamas atsisiuntimo laikotarpį pagal paskutinį sėkmingą duomenų gavimą. Tai sumažina duomenų trūkumus ir užtikrina, kad visada turėtumėte naujausius duomenis, net jei planinis atsisiuntimas keletą dienų nebuvo užbaigtas."
    },
    "driver number": "Vairuotojas {{driverNum}}",
    "driver schedules": {
      "description": "Vairuotojų tvarkaraščiai leidžia automatizuoti tachografo duomenų atsisiuntimą pasirinktiems vairuotojams. Pasirinkite vairuotojus, kuriems norite taikyti tvarkaraštį. Pasirinkite tvarkaraštį iš sąrašo ir spustelėkite „Taikyti“, kad jį aktyvuotumėte. Prireikus galite kurti, redaguoti ir trinti tvarkaraščius. Pastaba: kiekviena įmonė vienu metu gali turėti ne daugiau kaip 3 vairuotojų tvarkaraščius.",
      "description read-only": "Vairuotojų tvarkaraščiai leidžia automatizuoti tachografo duomenų atsisiuntimą pasirinktiems vairuotojams. Įmonės administratoriai gali kurti, redaguoti ir trinti tvarkaraščius pagal poreikį.",
      "title": "Vairuotojų tvarkaraščiai"
    },
    "due date": "Terminas",
    "edit schedule": {
      "description": {
        "drivers": {
          "global": "Globalus tvarkaraštis bus automatiškai taikomas visiems naujai pridėtiems vairuotojams. Tai galima pakeisti bendruosiuose nustatymuose.",
          "not global": "Šio tvarkaraščio pakeitimai turės įtakos visiems vairuotojams, kuriems taikomas šis tvarkaraštis."
        },
        "vehicles": {
          "global": "Globalus tvarkaraštis bus automatiškai taikomas visoms naujai pridėtoms transportams. Tai galima pakeisti bendruosiuose nustatymuose.",
          "not global": "Šio tvarkaraščio pakeitimai turės įtakos visoms transportams, kurioms taikomas šis tvarkaraštis."
        }
      },
      "title": {
        "global": "Globalus tvarkaraštis",
        "not global": "Redaguoti tvarkaraštį"
      }
    },
    "enter days": "Įveskite dienas",
    "every": "Kiekvienas",
    "fail reason": "Gedimo priežastis",
    "file types": {
      "Activities": "Veikla",
      "DetailedSpeed": "Išsamūs greičio duomenys",
      "EventsAndFaults": "Įvykiai ir gedimai",
      "Overview": "Apžvalga",
      "TechnicalData": "Techniniai duomenys"
    },
    "global schedule": {
      "connected to root company": "Susietas su pagrindinės įmonės bendruoju tvarkaraščiu.",
      "global icon info": "Globalus tvarkaraštis bus automatiškai taikomas visiems naujai užregistruotiems {{specificGlobalSchedule}}. Šią parinktį galite išjungti įmonės nustatymuose.",
      "info": {
        "edit driver schedule": "Globalus tvarkaraštis automatiškai bus taikomas visiems naujai užregistruotiems vairuotojams. Šią parinktį galite išjungti įmonės nustatymuose.",
        "edit schedule": "Globalus tvarkaraštis bus automatiškai taikomas visiems naujai užregistruotiems {{ variableName }}. Šią parinktį galite išjungti įmonės nustatymuose.",
        "edit vehicle schedule": "Globalus tvarkaraštis bus automatiškai taikomas visiems naujai užregistruotiems transportams. Šią parinktį galite išjungti įmonės nustatymuose."
      },
      "inherited settings": "Visos dukterinės įmonės automatiškai perima pagrindinės įmonės bendruosius tvarkaraščio nustatymus.",
      "not configured description": "Paspauskite mygtuką „Redaguoti“, kad pradėtumėte konfigūruoti bendrą tvarkaraštį.",
      "not configured description read-only": "Išsamūs tvarkaraščio duomenys bus rodomi, kai jis bus sukonfigūruotas.",
      "not configured title": "Globalus tvarkaraštis nenustatytas.",
      "not connected to root company": "Nesusietas su pagrindinės įmonės bendruoju tvarkaraščiu."
    },
    "include driver data": "Įtraukti vairuotojų duomenis",
    "include driver data tooltip": "Pasirinkite, ar greitojo tvarkaraščio vykdymo metu taip pat turėtų būti atsisiųsti vairuotojo (-ų) kortelės duomenys, kurie vykdymo metu yra įdėti į tachografą.\n<ul><li>Nėra – bus atsisiųsti tik transporto (VU) duomenys.</li><li>Vairuotojas 1 / Vairuotojas 2 – Atsisiųskite duomenis iš pasirinktos tachografo lizdo, jei jame yra vairuotojo kortelė.</li><li>Abu vairuotojai – duomenys bus atsisiųsti iš abiejų lizdų, jei juose yra kortelės.</li></ul>Jei vykdymo metu į pasirinktą lizdą nėra įdėta vairuotojo kortelė, vairuotojo duomenys nebus atsisiųsti.",
    "max number reached": "Pasiekėte didžiausią leidžiamą tvarkaraščių skaičių.",
    "name not valid": "Tvarkaraščio pavadinime negali būti daugiau nei {{maxNumber}} simbolių",
    "next attempt": "Kitas bandymas",
    "next date": "Kitas terminas",
    "next date and time": "Kitas data ir laikas",
    "next due date": "Kitas terminas",
    "quick schedule": {
      "description": "Pasirinkite duomenų tipus, kuriuos norite atsisiųsti.",
      "driver schedule quick download new": "Sukuria vienkartinį vairuotojo failų atsisiuntimo tvarkaraštį. Jis bus vykdomas, kai tik vairuotojas prisijungs prie programos.",
      "info banner": {
        "drivers": "Tai vienkartinis tvarkaraštis. Vairuotojo duomenų atsisiuntimas bus pradėtas, kai tik bus nustatytas vairuotojo ryšys su TachoSync.",
        "vehicles": "Tai vienkartinis tvarkaraštis. Transporto duomenų atsisiuntimas bus pradėtas, kai tik bus nustatytas transporto ryšys su TachoSync."
      },
      "success banner": "Tvarkaraštis užbaigtas, jį galima pašalinti paspaudus „Pašalinti tvarkaraštį“",
      "title": "Greitas tvarkaraštis",
      "vehicle schedule quick download deactivated": "Greitojo tvarkaraščio negalima pradėti deaktyvuotuose transportuose. Jei norite pradėti naują greitojo tvarkaraščio ciklą, pirmiausia aktyvuokite transportą.",
      "vehicle schedule quick download new": "Sukuria vienkartinį transporto duomenų atsisiuntimo tvarkaraštį. Jis bus įvykdytas, kai tik transportas prisijungs prie programos."
    },
    "repeat": "Pakartoti",
    "repeat every": "Kartoti kas",
    "repeat period": {
      "Biweekly": "Kas 14 dienų",
      "Custom": "Pagal užsakymą",
      "Daily": "Kasdien",
      "Every28Days": "Kas 28 dienas",
      "Every90Days": "Kas 90 dienų",
      "EveryDays": "Kas {{count}} dienų",
      "Hourly": "Valandinis",
      "Monthly": "Kas mėnesį",
      "Weekly": "Kas 7 dienas"
    },
    "schedule details": "„{{scheduleName}}“ informacija",
    "select date": "Pasirinkite datą",
    "start date": "Pradžios data",
    "start date and time": "Pradžios data ir laikas",
    "vehicle schedules": {
      "description": "Transportų tvarkaraščiai leidžia automatizuoti tachografo duomenų atsisiuntimą pasirinktoms transportams. Pasirinkite transportus, kurioms norite taikyti tvarkaraštį. Iš sąrašo pasirinkite tvarkaraštį ir spustelėkite „Taikyti“, kad jį aktyvuotumėte. Prireikus galite kurti, redaguoti ir trinti tvarkaraščius. Pastaba: Kiekviena įmonė vienu metu gali turėti ne daugiau kaip 3 transportų tvarkaraščius.",
      "description read-only": "Transportų tvarkaraščiai leidžia automatizuoti tachografo duomenų atsisiuntimą pasirinktoms transportams. Įmonės administratoriai gali kurti, redaguoti ir trinti tvarkaraščius pagal poreikį.",
      "download data activities tooltip hourly": "Bus atsisiųsti tos dienos veiklos duomenys",
      "download data activities tooltip monthly": "Prieš kiekvieną važiavimo datą bus atsisiųsti praėjusio mėnesio duomenys",
      "download data activities tooltip multiple": "Bus atsisiųsti duomenys už paskutines {{repeatDays}} dienas iki kiekvienos važiavimo datos",
      "download data activities tooltip single": "Veiklos duomenys bus atsisiųsti už paskutinę dieną prieš kiekvieną važiavimo datą",
      "title": "Transportų tvarkaraščiai"
    }
  },
  "Search": {
    "find device": {
      "error not valid": "IMEI turi būti sudarytas iš 15 simbolių",
      "find device": "Rasti įrenginį",
      "no vehicle found": "Transporto nerasta",
      "no vehicle found description": "Transporto nerasta. Įveskite kito įrenginio IMEI numerį.",
      "only numbers": "Galioja tik skaičiai",
      "search for vehicles by their IMEI": "Transportų paieška pagal įrenginio IMEI numerį",
      "search vehicle IMEI": "Įrenginio IMEI paieška"
    },
    "search": "Ieškoti...",
    "search child company": "Ieškoti dukterinės įmonės",
    "search company name": "Ieškoti įmonės pavadinimo",
    "search in driverFiles": "Paieška pagal vairuotoją arba vairuotojo identifikatorių",
    "search in drivers": "Paieška pagal pavadinimą arba vairuotojo identifikatorių",
    "search in integrations": "Paieška pagal pavadinimą",
    "search in users": "Paieška pagal el. paštą",
    "search in vehicleFiles": "Paieška pagal transporto IMEI arba VRN numerį",
    "search in vehicles": "Paieška pagal transporto IMEI arba VRN numerį"
  },
  "Security": {
    "2FA": {
      "get email code": {
        "description": "Įveskite šį kodą kitame ekrane, kad patvirtintumėte savo paskyrą.",
        "description modal": "Naudokite šį kodą, kad patvirtintumėte savo paskyrą.",
        "title": "Paspaudus mygtuką „Siųsti kodą“, unikalus kodas bus išsiųstas į <1>{{email}}</1>."
      },
      "select authentication type": {
        "authentication app description": "Gaukite unikalų kodą iš tokios programėlės kaip „Microsoft Authenticator“ arba „Google Authenticator“.",
        "description": "Siekiant užtikrinti jūsų paskyros ir klientų duomenų saugumą, prašome pasinaudoti viena iš toliau nurodytų galimybių ir nustatyti dviejų žingsnių autentifikavimą.",
        "description modal": "Pasirinkite pageidaujamą autentifikavimo būdą.",
        "email": "El. paštas",
        "email description": "Kiekvieną kartą, kai bandysite prisijungti, į jūsų el. paštą išsiųsime vienkartinį kodą.",
        "recommended": "Rekomenduojama",
        "title": "Dviejų žingsnių autentifikavimas (2FA) yra privalomas visiems TachoSync naudotojams.",
        "title modal": "Pasirinkite autentifikavimo būdą"
      },
      "send email code": {
        "description": "Įveskite kodą į žemiau esantį laukelį ir spauskite „Patikrinti“, kad galėtumėte tęsti.",
        "enter code": "Įveskite kodą, kad patvirtintumėte el. pašto adresą.",
        "title": "Unikalus kodas buvo išsiųstas į <1>{{email}}</1>.",
        "verification code": "Patvirtinimo kodas"
      },
      "send otp code": {
        "click to scan code": "Spauskite čia, jei norite nuskaityti QR kodą",
        "click to type code": "Spauskite čia, jei norite kodą įvesti rankiniu būdu",
        "incorrect code": "Neteisingas kodas",
        "scan QR code": "Nuskaitykite QR kodą savo programėlėje",
        "six digit code": "Jūsų programėlės sukurtas 6 skaitmenų kodas",
        "type text code": "Įveskite teksto kodą į savo programėlę",
        "title": "Norėdami užbaigti šį procesą, jums reikės mobiliosios autentifikavimo patvirtinimo programos, pvz.: <1>„Microsoft Authenticator“</1> arba <2>„Google Authenticator“</2>."
      },
      "success message": {
        "alert": "Dviejų žingsnių autentifikavimas sėkmingai įjungtas.",
        "description": "Kiekvieną kartą, kai prisijungsite naudodami savo el. pašto adresą ir slaptažodį, paprašysime įvesti autentifikavimo kodą.",
        "title": "Jūs sėkmingai įjungėte dviejų žingsnių autentifikavimą.",
        "title modal": "Įjungtas dviejų žingsnių autentifikavimas!"
      },
      "title": {
        "authentication app": "Autentifikavimo programa",
        "authentication email": "Autentifikavimo el. laiškas",
        "is enabled": "Įjungtas dviejų žingsnių autentifikavimas.",
        "protect your account": "Apsaugokite savo TachoSync paskyrą"
      }
    }
  },
  "Selector": {
    "client company": "Kliento įmonė",
    "company selector": "Įmonės pasirinkimas",
    "companies": "Įmonės ({{companyCount}})"
  },
  "Settings": {
    "CCA file size": "Failo dydis 83,5 MB",
    "change password": "Pakeisti slaptažodį",
    "company card authenticator": "Company Card Authenticator",
    "email notifications": {
      "credits purchased": "Įsigyti kreditai",
      "low credits alerts": "Įspėjimai apie mažą kreditų likutį",
      "title": "Pranešimai el. paštu",
      "tooltip": "Nustatykite, kokius su kreditu susijusius el. laiškus norite gauti."
    },
    "feature switches": "Funkcijų perjungikliai",
    "file format settings": {
      "description": "Pasirinkite, kokiu formatu turi būti rodomi tachografo failai. Galimi formatai: europietiškas (.DDD), prancūziškas (.V1B – transporto duomenims ir .C1B – vairuotojo duomenims) ir ispaniškas (.TGD).",
      "title": "Failų formato nustatymai"
    },
    "file formats": {
      "DDD": ".DDD",
      "TGD": ".TGD",
      "V1BC1B": ".V1B, .C1B"
    },
    "general settings": "Bendrieji nustatymai",
    "security": "Saugumas",
    "time settings": {
      "date display format tooltip": "Pasirinkite datos rodymo formatą programoje TachoSync.\nPvz.: DD-MM-YYYY = 14-05-2024",
      "description": "Laiko juostą nustatykite automatiškai pagal savo dabartinę buvimo vietą arba pasirinkite pageidaujamą laiko juostą ir formatą, kuriuo bus rodomi visi laiko žymėjimai.",
      "time and date format toggle": "Automatiškai nustatyti laiko ir datos formatą",
      "title": "Laiko nustatymai"
    },
    "tutorials": "Mokomieji vadovai",
    "version": "Versija"
  },
  "Table": {
    "activity period": "Veiklos laikotarpis",
    "Automatic initial Driver Download": "Automatinis pradinis vairuotojo duomenų atsisiuntimas",
    "Automatic initial Vehicle Download": "Automatinis pirminis transporto priemonės duomenų atsisiuntimas",
    "card name": "Pavadinimas",
    "card number": "Vairuotojo identifikatorius",
    "cardnumber": "Vairuotojo identifikatorius",
    "comment": "Komentaras",
    "company": "Įmonė",
    "connection status": "Ryšio būsena",
    "created at": "Sukurta",
    "created by": "Sukūrė",
    "credit status": "Kredito būklė",
    "day ago": "Prieš 1 dieną",
    "days ago": "{{daysNum}} dienų prieš",
    "data types": "Duomenų tipai",
    "description": "Aprašymas",
    "device imei": "Įrenginio IMEI",
    "device imei empty": "Transportui nėra priskirtas IMEI kodas. Norint prijungti įrenginį ir atsisiųsti failus, būtinas galiojantis IMEI kodas. Eikite į transporto redagavimo meniu ir įveskite galiojantį IMEI kodą, kad būtų galima atsisiųsti transporto failus.",
    "device status": "Įrenginio būsena",
    "downloaded at": "Atsisiųsta",
    "driver": "Vairuotojas",
    "driver name": "Vairuotojo vardas ir pavardė",
    "drivers name": "Vairuotojo vardas ir pavardė",
    "email": "El. paštas",
    "empty table": {
      "button": {
        "add": {
          "analysis providers": "Pridėti integraciją",
          "driver files": "Pridėti vairuotojo failą",
          "drivers": "Pridėti vairuotoją",
          "integrations": "Pridėti integraciją",
          "integrations api": "Pridėti integraciją",
          "users": "Pakviesti naudotoją",
          "vehicle files": "Pridėti transporto priemonės failą",
          "vehicles": "Pridėti transportą"
        },
        "reset view": "Atstatyti peržiūrą"
      },
      "no initial results": {
        "description": {
          "analysis providers": "Kai tik analizės paslaugų teikėjai bus pridėti į TachoSync, \nšį sąrašą galėsite peržiūrėti čia.",
          "company cards": "Kai tik bus pridėtos įmonės kortelės, jų sąrašą galėsite peržiūrėti čia.",
          "companies": "Kai tik įmonės bus pridėtos į TachoSync,\njų sąrašą galėsite peržiūrėti čia.",
          "driver files": "Kai tik vairuotojo failai bus įkelti į TachoSync,\nšį sąrašą galėsite peržiūrėti čia.",
          "drivers": "Kai tik vairuotojai bus įtraukti į TachoSync,\njų sąrašą galėsite peržiūrėti čia.",
          "integrations": "Kai tik integracijos bus pridėtos į TachoSync, \njūs galėsite peržiūrėti sąrašą čia.",
          "integrations api": "Kai tik API raktų bus pridėta į TachoSync,\njų sąrašą galėsite peržiūrėti čia.",
          "users": "Kai tik naudotojai bus pridėti į TachoSync, \nšioje vietoje galėsite peržiūrėti jų sąrašą.",
          "users invitations": "Kai tik naudotojai bus pakviesti prisijungti prie TachoSync,\nšį sąrašą galėsite peržiūrėti čia.",
          "vehicle files": "Kai tik transporto priemonių failai bus įkelti į TachoSync,\njūs galėsite peržiūrėti sąrašą čia.",
          "vehicles": "Kai tik transporto priemonės bus pridėtos į TachoSync,\njų sąrašą galėsite peržiūrėti čia."
        },
        "title": {
          "analysis providers": "Kol kas nėra analizės teikėjų",
          "company cards": "Įmonių kortelių lentelė yra tuščia",
          "companies": "Įmonių lentelė tuščia",
          "driver files": "Vairuotojų duomenų lentelė yra tuščia",
          "drivers": "Vairuotojų lentelė tuščia",
          "integrations": "Kol kas nėra integracijų",
          "integrations api": "API raktų dar nėra",
          "users": "Naudotojų lentelė tuščia",
          "users invitations": "Naudotojų kvietimų lentelė tuščia",
          "vehicle files": "Transporto priemonių failų lentelė tuščia",
          "vehicles": "Transporto priemonų lentelė tuščia"
        }
      },
      "no results found": {
        "description": "Išbandykite kitą raktinį žodį arba filtrą, kad gautumėte daugiau \nrezultatų.",
        "title": "Rezultatų nerasta"
      }
    },
    "enable": "Įjungti",
    "expiration date": "Galiojimo pabaigos data",
    "expired integration tooltip": "Integracija nebegalioja ir jos neįmanoma įjungti",
    "file name": "Failo pavadinimas",
    "Global schedule": "Globalus tvarkaraštis",
    "imei": "IMEI",
    "invitation status": "Kvietimo būsena",
    "invited at": "Pakviestas",
    "invited by": "Kvietė",
    "last activity": "Paskutinė veikla",
    "last connected": "Paskutinis prisijungimas",
    "last connection": "Paskutinis prisijungimas",
    "last download": "Paskutinis atsisiuntimas",
    "last download date": "Paskutinis atsisiuntimas: {{date}}",
    "last event": "Paskutinis įvykis",
    "last vehicle used": "Paskutinė naudota transportas",
    "method": "Metodas",
    "name": "Pavadinimas",
    "next download": "Kitas atsisiuntimas",
    "No schedule applied": "Tvarkaraštis nepriskirtas",
    "No schedules": "Nėra tvarkaraščių",
    "number": "Skaičius",
    "Overdue": "Vėluojama",
    "parent company": "Motininė įmonė",
    "plate number": "Transporto valstybinis numeris",
    "provider": "Teikėjas",
    "Quick schedule": "Greitas tvarkaraštis",
    "role": "Rolė",
    "rows per page": "Eilučių skaičius puslapyje",
    "schedule": "Tvarkaraštis",
    "schedules": "Tvarkaraščiai",
    "seen at": "Pastebėta",
    "select columns to show": "Pasirinkite rodomus stulpelius",
    "show details": {
      "companies": "Rodyti įmonės duomenis",
      "drivers": "Rodyti vairuotojo duomenis",
      "integrations": "Rodyti integracijos detales",
      "vehicles": "Rodyti transporto duomenis"
    },
    "status": "Būklė",
    "today": "Šiandien",
    "updated at": "Atnaujinta",
    "vehicle": "Transportas",
    "vehicle name": "Transporto pavadinimas",
    "vehicle number": "VRN",
    "vehicles": "Transportas"
  },
  "Tabs": {
    "analysis providers": "Analizės paslaugų teikėjai",
    "api": "API",
    "invitations": "Kvietimai",
    "sftp": "SFTP",
    "users": "Naudotojai"
  },
  "Tooltip": {
    "delete company action": "Viena ar kelios pasirinktos įmonės turi dukterines įmones ir negali būti ištrintos. Norėdami ištrinti pasirinktas įmones, pirmiausia ištrinkite visas dukterines įmones.",
    "no action permission": "Jūs neturite leidimo atlikti šią veiksmą",
    "parent company": "Didžiausias leidžiamas įmonių lygmenų skaičius įmonių medyje yra {{maxAllowedLevels}}. Įmonė „{{companyName}}“ yra {{maxAllowedLevels}}-ajame lygmenyje, todėl jai negalima pridėti jokių pavaldžių įmonių."
  },
  "Tutorials": {
    "add company card": {
      "desktop": {
        "fifth step": {
          "content": "Norėdami pridėti naują įmonės kortelę, spustelėkite paryškintą mygtuką <strong>„Pridėti naują“</strong>. Atsidarius įmonės pridėjimo langui, užpildykite reikiamus laukelius ir spustelėkite mygtuką <strong>„Išsaugoti“</strong>, kad užbaigtumėte.\n\nPastaba: Įmonės kortelės ID galima rasti Company Card Authenticator programoje, stulpelyje „Card ID“.\n\nSpustelėkite „<strong>Toliau</strong>“, kad tęstumėte.",
          "title": "Pridėti naują įmonės kortelę"
        },
        "final step": {
          "content": "Visos pridėtos kortelės ir jų duomenys bus išvardyti skiltyje „Įmonės kortelės“.\n\nPastaba: Šį vadovėlį visada galite pakartoti, eidami į „Nustatymai“ – „Vadovėliai“. \n\nSpustelėkite „<strong>Baigti</strong>“, kad užbaigtumėte vadovėlį.",
          "title": "Įmonės kortelės duomenys"
        },
        "first step": {
          "content": "Prieš įtraukdami įmonės kortelę į TachoSync, įsitikinkite, kad atsisiuntėte ir įdiegėte Company Card Authenticator programą. Tai galima padaryti bet kuriuo metu iš meniu „Nustatymai“.\n\nCompany Card Authenticator nuskaitys ir parodys informaciją iš į jūsų kortelių skaitytuvą įdėtų įmonės kortelių bei įgalins nuotolinį autentifikavimą.\n\nSpustelėkite <strong>„Pradėti“</strong>, kad pradėtumėte.",
          "title": "Company Card Authenticator"
        },
        "fourth step": {
          "content": "Dešinėje pusėje matote įmonės duomenų skydelį. Čia rasite visą informaciją apie sukurtą įmonę.\n\nSpustelėkite „<strong>Toliau</strong>“, kad tęstumėte.",
          "title": "Įmonės duomenys"
        },
        "second step": {
          "content": "Naudodamiesi kairiuoju šoniniu meniu, pereikite prie paryškinto puslapio „<strong>Įmonės</strong>“.",
          "title": "Įmonių puslapis"
        },
        "third step": {
          "content": "Norėdami peržiūrėti įmonių kortelių ekraną, pirmiausia turite paspausti ant vienos iš įmonių.\n\nŠio pamokymo tikslais pasirinkite paryškintą įmonę, esančią lentelės viršuje.",
          "title": "Pasirinkite įmonę"
        }
      },
      "mobile": {
        "fifth step": {
          "content": "Norėdami pridėti naują įmonės kortelę, spustelėkite paryškintą mygtuką „Pridėti naują“. Kai atsivers įmonės pridėjimo langas, užpildykite reikiamus laukelius ir spustelėkite mygtuką „Išsaugoti“, kad užbaigtumėte.\n\nPastaba: Įmonės kortelės ID galima rasti Company Card Authenticator programoje, lentelės stulpelyje „Kortelės ID“.\n\nSpustelėkite „<strong>Toliau</strong>“, kad tęstumėte.",
          "title": "Pridėti naują įmonės kortelę"
        },
        "final step": {
          "content": "Visos pridėtos kortelės bus išvardytos paryškintame skyriuje „Įmonės kortelės“. Ten matysite kortelės būseną, galiojimo datą ir ID.\n\nPastaba: šį vadovą visada galite pakartoti, eidami į „Nustatymai“ – „Vadovai“. \n\nSpustelėkite „<strong>Baigti</strong>“, kad užbaigtumėte vadovą.",
          "title": "Įmonės kortelės duomenys"
        },
        "first step": {
          "content": "Pirmiausia turime pereiti į puslapį „Įmonės“, kuris yra <strong>meniu</strong>, esančiame viršutiniame dešiniajame kampe.\n\nSpustelėkite paryškintą sritį, kad atidarytumėte meniu.",
          "title": "Atidaryti meniu"
        },
        "fourth step": {
          "content": "Čia rasite visą informaciją apie įsteigtą įmonę.\n\nSpustelėkite „<strong>Toliau</strong>“, kad tęstumėte.",
          "title": "Įmonės duomenys"
        },
        "second step": {
          "content": "Norėdami atidaryti puslapį „Įmonės“, spustelėkite paryškintą sritį.",
          "title": "Įmonių puslapis"
        },
        "third step": {
          "content": "Čia galite peržiūrėti visų įmonių sąrašą.\nNorėdami peržiūrėti konkrečios įmonės kortelę, atidarykite <strong>įmonės informacijos</strong> langą, spustelėdami paryškintą mygtuką.",
          "title": "Daugiau informacijos"
        }
      },
      "name": "Pridėti įmonės kortelę"
    },
    "add vehicle": {
      "first step": {
        "content": "Norėdami pritaikyti tvarkaraštį, turite pridėti bent vieną transportą.\n\nPridėkime transportą, paspaudę paryškintą mygtuką „<strong>Pridėti transportą</strong>“.\n\nKituose ekrane užpildykite visus reikiamus laukelius ir paspauskite mygtuką <strong>„Pridėti“</strong>, kad užbaigtumėte transporto pridėjimą.",
        "title": "Pridėto transporto nėra"
      },
      "name": "Pridėti transportą"
    },
    "apply schedule": {
      "desktop": {
        "fifth step": {
          "content": "Pasirinkus tvarkaraštį, mygtukas „<strong>Taikyti</strong>“ taps aktyvus.\n\nSpustelėkite mygtuką „Taikyti“.\n\nSpustelėkite „<strong>Toliau</strong>“, kad tęstumėte.",
          "title": "Pasirinkite taikytiną tvarkaraštį"
        },
        "final step": {
          "content": "Sėkmingai pritaikius tvarkaraštį transportui, duomenų atsisiuntimas prasidės pagal numatytą laiką.\n\nVisi transportui ar vairuotojui pritaikyti tvarkaraščiai bus rodomi paryškintame skydelyje „Daugiau informacijos“.\n\nSpustelėkite „<strong>Baigti</strong>“, kad užbaigtumėte pamoką.",
          "title": "Tvarkaraštis sėkmingai pritaikytas"
        },
        "first step": {
          "content": "Transporto tvarkaraščiai yra puslapyje „<strong>Transporto</strong>“, o vairuotojų tvarkaraščiai – puslapyje „Vairuotojai“.\n\nKadangi abiejuose puslapiuose procesas yra panašus, šiame vadove pasirinkite paryškintą puslapį „Transporto“.",
          "title": "Transporto arba vairuotojų tvarkaraštis"
        },
        "fourth step": {
          "content": "Spustelėkite tvarkaraštį, kad jį pritaikytumėte pasirinktam (-iems) transportui (-ėms).\n\nSpustelėkite „<strong>Toliau</strong>“, kad tęstumėte",
          "title": "Pasirinkite taikytiną tvarkaraštį"
        },
        "second step": {
          "content": "Prieš taikydami tvarkaraštį, pasirinkite vieną ar daugiau transporto priemonių.\n\nŠio pamokymo tikslais pasirinkite pirmąją transportą lentelėje, spustelėdami paryškintą mygtuką.",
          "title": "Pasirinkite transportą"
        },
        "third step": {
          "content": "Dabar, kai jau pasirinkote transportą, mygtukas „<strong>Tvarkaraščiai</strong>“ taps aktyvus.\n\nSpustelėkite paryškintą mygtuką „Tvarkaraščiai“, kad tęstumėte.",
          "title": "Atviri tvarkaraščiai"
        }
      },
      "mobile": {
        "fifth step": {
          "content": "Dabar, kai jau pasirinkote transportą, mygtukas „<strong>Tvarkaraščiai</strong>“ turėtų tapti paryškintas.\n\nSpustelėkite paryškintą mygtuką „Tvarkaraščiai“, kad tęstumėte.",
          "title": "Atidaryti tvarkaraščius"
        },
        "final step": {
          "content": "Sėkmingai pritaikius tvarkaraštį transportui, duomenų atsisiuntimas prasidės pagal numatytą laiką.\nVisi transportui ar vairuotojui pritaikyti tvarkaraščiai bus rodomi paryškintame skydelyje <strong>„Daugiau informacijos“</strong>.\n\nSpustelėkite „<strong>Baigti</strong>“, kad užbaigtumėte mokomąją programą.",
          "title": "Tvarkaraštis sėkmingai pritaikytas"
        },
        "first step": {
          "content": "Transportų tvarkaraščiai yra puslapyje „Transporto“, o vairuotojų tvarkaraščiai – puslapyje „Vairuotojai“.\n\nKadangi abiejuose puslapiuose procesas yra panašus, šiame vadove pasirinkime paryškintą „Transportas“ puslapį.",
          "title": "Transportų arba vairuotojų tvarkaraštis"
        },
        "fourth step": {
          "content": "Šiame pamokymetyje pasirinkime pirmąją lentelėje esančią transportą, spustelėdami paryškintą mygtuką.",
          "title": "Pasirinkite transportą"
        },
        "second step": {
          "content": "Kadangi abiejuose puslapiuose procesas yra panašus, šiame vadove pasirinkime paryškintą <strong>„Transportų puslapį“</strong>.",
          "title": "Transportų puslapis"
        },
        "seventh step": {
          "content": "Pasirinkus tvarkaraštį, paryškintas mygtukas „<strong>Taikyti</strong>“ taps aktyvus. Spustelėjus jį, tvarkaraštis bus pritaikytas pasirinktam transportui.\n\nSpustelėkite „<strong>Toliau</strong>“, kad tęstumėte.",
          "title": "Pasirinkite taikytiną tvarkaraštį"
        },
        "sixth step": {
          "content": "Pasirinkę transportą, galite pasirinkti taikytiną tvarkaraštį, spustelėdami jį.\n\nSpustelėkite „<strong>Toliau</strong>“, kad tęstumėte",
          "title": "Pasirinkite taikytiną tvarkaraštį"
        },
        "third step": {
          "content": "Prieš pritaikydami tvarkaraštį, pirmiausia turite pasirinkti vieną ar kelis transportus.\nNorėdami pradėti, spustelėkite paryškintą mygtuką „Pasirinkti eilutes “.",
          "title": "Atidaryti pasirinkimo įrankį"
        }
      },
      "name": "Taikyti tvarkaraštį"
    },
    "company selector": {
      "desktop": {
        "first step": {
          "content": "Viršutiniame meniu esantis įmonių pasirinkimo meniu leidžia pasirinkti įmonę, su kuria norite dirbti programoje TachoSync.\nTai reikalinga, jei valdote daugiau nei vieną įmonę.\n\nSpustelėkite <strong>paryškintą</strong> mygtuką, kad atidarytumėte įmonių pasirinkimo meniu.",
          "title": "Atidaryti įmonių pasirinkimo meniu"
        },
        "second step": {
          "content": "Įmonių pasirinkimo ekrane galite pasirinkti konkrečią įmonę, su kuria norite dirbti. Kituose meniu matysite tik su pasirinkta įmone susijusius išteklius. Atsijungus iš TachoSync, visada bus išsaugotas paskutinis pasirinkimas.",
          "title": "Įmonės pasirinkimas"
        }
      },
      "mobile": {
        "first step": {
          "content": "Viršutiniame meniu esantis įmonių pasirinkimo meniu leidžia pasirinkti įmonę, su kuria norite dirbti TachoSync programoje.\nTai reikalinga, jei valdote daugiau nei vieną įmonę.\n\nSpustelėkite <strong>paryškintą</strong> mygtuką, kad atidarytumėte įmonių pasirinkimo meniu.",
          "title": "Atidaryti įmonių pasirinkimo meniu"
        },
        "second step": {
          "content": "Įmonių pasirinkimo ekrane galite pasirinkti konkrečią įmonę, su kuria norite dirbti. Kituose meniu matysite tik su pasirinkta įmone susijusius išteklius. Atsijungus iš TachoSync, visada bus išsaugotas paskutinis pasirinkimas.",
          "title": "Įmonės pasirinkimas"
        }
      },
      "name": "Įmonės pasirinkimas"
    },
    "create schedule": {
      "desktop": {
        "fifth step": {
          "content": "Sukūrus tvarkaraštį, jį reikia pritaikyti pasirinktoms transporto priemonėms arba vairuotojams. Kaip pritaikyti tvarkaraščius, sužinosite peržiūrėję pamoką „<strong>Tvarkaraščio pritaikymas</strong>“.\n\nSpustelėkite „<strong>Toliau</strong>“, kad tęstumėte.",
          "title": "Tvarkaraštis netaikomas"
        },
        "final step": {
          "content": "Sveikiname, jūs sėkmingai išmokote kurti tvarkaraštį.\n\nToliau išmokite, kaip pritaikyti tvarkaraštį pasirinktiems elementams.\n\nSpustelėkite „<strong>Baigti</strong>“, kad užbaigtumėte pamoką.",
          "title": "Sukurti tvarkaraštį – užduotis įvykdyta"
        },
        "first step": {
          "content": "Tvarkaraštis – tai iš anksto nustatytas planas, pagal kurį nustatytu laiku ir intervalais automatiškai atsisiunčiami tachografo duomenys iš jūsų transporto priemonių arba vairuotojų. Nustačius pradžios datą, laiką ir dažnumą (pavyzdžiui, kasdien), tvarkaraštis užtikrina, kad duomenys būtų nuosekliai renkami be jokio rankinio įsikišimo.\n\nSpustelėkite <strong>„Pradėti“</strong>, kad galėtumėte pradėti.",
          "title": "Kas yra tvarkaraštis?"
        },
        "fourth step": {
          "content": "Šiame ekrane galite kurti, redaguoti, sustabdyti arba pašalinti tvarkaraščius. Pirmoji vieta visada skirta bendrajam tvarkaraščiui, kurio pašalinti negalima.",
          "title": "Tvarkaraščiai"
        },
        "second step": {
          "content": "Transporto priemonių tvarkaraščiai yra puslapyje <strong>„Transporto priemonės“</strong>. Vairuotojų tvarkaraščiai yra puslapyje „Vairuotojai“.\n\nKadangi abiejuose puslapiuose procesas yra panašus, šiame vadove pasirinkite paryškintą puslapį „Transporto priemonės“.",
          "title": "Transporto priemonių arba vairuotojų tvarkaraštis"
        },
        "third step": {
          "content": "Tvarkaraštį galima sukurti ir redaguoti lange <strong>„Tvarkaraščiai“</strong> bet kuriuo metu, nepriklausomai nuo to, ar jau pridėti kokie nors transporto priemonės ar vairuotojai.\n\nSpustelėkite paryškintą mygtuką „Tvarkaraščiai“, kad tęstumėte.",
          "title": "Atviri tvarkaraščiai"
        }
      },
      "mobile": {
        "fifth step": {
          "content": "Šiame ekrane galite kurti, redaguoti, laikinai sustabdyti arba pašalinti bet kurį sukurtą tvarkaraštį. Pirmoji vieta visada skirta bendrajam tvarkaraščiui, kurio pašalinti negalima.",
          "title": "Tvarkaraščiai"
        },
        "final step": {
          "content": "Sveikiname, jūs sėkmingai išmokote kurti tvarkaraštį.\n\nToliau sužinokite, kaip pritaikyti tvarkaraštį pasirinktiems elementams.\n\nSpustelėkite „<strong>Baigti</strong>“, kad užbaigtumėte pamoką.",
          "title": "Sukurti tvarkaraštį – užbaigta"
        },
        "first step": {
          "content": "Tvarkaraštis – tai iš anksto nustatytas planas, pagal kurį nustatytu laiku ir intervalais automatiškai atsisiunčiami tachografo duomenys iš jūsų transporto priemonių arba vairuotojų. Nustačius pradžios datą, laiką ir dažnumą (pavyzdžiui, kasdien), tvarkaraštis užtikrina, kad duomenys būtų nuosekliai renkami be jokio rankinio įsikišimo.\n\nSpustelėkite <strong>„Pradėti“</strong>, kad pradėtumėte.",
          "title": "Kas yra tvarkaraštis?"
        },
        "fourth step": {
          "content": "Tvarkaraštį galima sukurti ir redaguoti lange <strong>„Tvarkaraščiai“</strong> bet kuriuo metu, nepriklausomai nuo to, ar buvo pridėti kokie nors transporto priemonės ar vairuotojai.\n\nSpustelėkite paryškintą mygtuką „Tvarkaraščiai“, kad tęstumėte.",
          "title": "Atviri tvarkaraščiai"
        },
        "second step": {
          "content": "Transporto priemonių tvarkaraščiai yra puslapyje „Transporto priemonės“, o vairuotojų tvarkaraščiai – puslapyje „Vairuotojai“.\n\n Norėdami pereiti į šiuos puslapius, pirmiausia atidarykime <strong>meniu</strong>.",
          "title": "Transporto priemonių arba vairuotojų tvarkaraštis"
        },
        "sixth step": {
          "content": "Sukūrus tvarkaraštį, jį reikia pritaikyti pasirinktoms transporto priemonėms arba vairuotojams. Kaip tai padaryti, paaiškinta kitame vadove „<strong>Tvarkaraščio pritaikymas</strong>“.\n\nSpauskite „<strong>Toliau</strong>“, kad tęstumėte.",
          "title": "Tvarkaraštis netaikomas"
        },
        "third step": {
          "content": "Kadangi procesas abiejuose puslapiuose yra panašus, šiame vadove pasirinkime paryškintą <strong>„Transporto priemonių puslapį“</strong>",
          "title": "Transportai puslapis"
        }
      },
      "name": "Sukurti tvarkaraštį"
    }
  }
}
